import { HISTORY,
         INFO,
		 CONSTS,
		 TIMES,
         CONES,
         REACT_STATES,
         STATS, 
		 CloneObject,
         clearTURNS,
         clearRUNS,
         initHistory,
         RUNS,
         BTURNS,
         PTURNS} from '../util/object'
import { calcDegree,
         setFrameEvent,
         NOW,
         calcDistance} from "../util/util";
import { pickRandomIndex,
         } from "../util/tools";
import { guiState } from '../util/aiMain';
import { playAudio,
         recordOutput,
         initWebcamAI,
         } from "../util/videoUtil";
import { timerDisplayResult,
         displayBlock,
         } from "../util/annotate";

import { ConeObj } from "../util/template";


// handle calibration for diff modes
//     - 2-cone: calibrate left-front
//     - 4-cone: calibrate left-front and right-rear
//     - practice: calibrate center
//
export function processCalibration() {
    if (INFO.has_calibration  === true) {
        //console.log("calib.39:     . . . . ALREADY CALIBRATED");
        return;
    }

    // gather info for display: show person/footprint target in analyzeBall()
    var [ idx, valid_cnt ] = selectCalibrationCone();	 // find the front and back opposit corner cones
    //console.log("calib.42:   CALIB            calib=", INFO.has_calibration, " valid_cnt=",valid_cnt, " idx=",idx);
    if ((valid_cnt > 0) && (idx >= 0)) {
        var use_x = CONES[idx].ctr_x;
        var use_y = CONES[idx].ctr_y;

        var fw2 = CONSTS.FOOT_CALIB_SIZEX  * INFO.scale_x;		// do not change scale
        var fh2 = CONSTS.FOOT_CALIB_SIZEY  * INFO.scale_y;  // * 0.9;
        var xx = use_x - fw2;           // upper left for footprint
        var yy = use_y;                 // upper left

        //console.log("foot.1624:   FOOT            xx=",xx, " yy=",yy, " fw2=",fw2, " fh2=",fh2);
        INFO.calib_xx = xx;
        INFO.calib_yy = yy;
        INFO.calib_ww = fw2;    // 379
        INFO.calib_hh = fh2;    // 287
    }
}


// wipe out calibration
export function resetCalibration() {
    INFO.has_calibration = false;
    INFO.calib_xx = 0;
    INFO.calib_xx = 0;
    INFO.calib_ww = 0;
    INFO.calib_hh = 0;
}



// femur calibration sequence:
//     - select front-right most cone
//     - then left-back most cone
//
export function selectCalibrationCone() {
    var idx = -1, min_x = 9999999, min_y = 9999999; 
    var max_x = 0, max_y = 0, valid_cnt = 0;

    var tids = filterCones(INFO.show_virtual_cones_only);
    //console.log("sel_calib.91:   SEL_CALIB           CONES=", CONES, "  tids=",tids);
	for(var i = 0; i < CONES.length; i++) {
		var cone = CONES[i];
        var found = false;
        for(var j=0; j< tids.length; j++) {
            var tid = tids[j];      // lock those filtered and identified
            if (cone.id === tid) {
                found = true;
            }
        }

        if ((found  === true) && (cone.valid  === true)) {
            valid_cnt = valid_cnt + 1;
            if (INFO.calibrate_cnt === 0) {
                if ((cone.ctr_y > max_y) && (cone.ctr_x > max_x)) {
                    idx = i;
                    max_y = cone.ctr_y;
                    max_x = cone.ctr_x;
                }
            } else {
                if ((cone.ctr_y < min_y) && (cone.ctr_x < min_x)) {
                    idx = i;
                    min_y = cone.ctr_y;
                    min_x = cone.ctr_x;
                }
            }
        }
        if(CONES[i] !== undefined)
            CONES[i].target = false;
    }

    if(CONES[idx] !== undefined) {
        CONES[idx].target = (idx >= 0) ? true : false;
        INFO.target_x = CONES[idx].ctr_x;
        INFO.target_y = CONES[idx].ctr_y;
        //console.log("select.260:   ######  CALIB CONE SELECTED  ",idx, "  id=",CONES[idx].id, " vcnt=",valid_cnt," tids=",tids);
    } else {
        idx = -1;
        INFO.cone_target_x = 0;
        INFO.cone_target_y = 0;
        INFO.target_x = 0;
        INFO.target_y = 0;
    }

    return [ idx, valid_cnt ];
}



// generate a set of fake cones since player doesn't have enough
//
export function setFakeCones(cone_cnt) {
    //console.log("set_fake.141:   SET_FAKE         pose_bot=",INFO.pose_bot, " cones.len=",CONES.length);
    if (!INFO.pose_bot || (CONES.length >= cone_cnt)) return;     // do not set fake cone until we know the camera angle
    if ((INFO.pose_bot - INFO.pose_top) < 5) return;     // do not set fake cone until we get a reasonable pose reading

    var cone1 = {}
	var canvas = INFO.out_canvas;
    var width = (canvas == null) ? 600 : canvas.width;
    var height = (canvas == null) ? 400 : canvas.height;
    var cwidth1 = Math.floor(width / 35);       // proportional cone size to screen     30
    var cheight1 = Math.floor(height / 22);     // 20
    var cwidth2 = Math.floor(cwidth1 * 1.3);
    var cheight2 = Math.floor(cheight1 * 1.3);
    const FOOTX = (CONSTS.FOOT_CALIB_SIZEX * INFO.scale_x);
    const FOOTY = (CONSTS.FOOT_CALIB_SIZEY * INFO.scale_y);

    var cone = {};
    cone.valid_cnt = 9999;			// start with some so not eliminated right away
    cone.veri_cnt = 9999;			// count to confirm verification
    cone.tmp = 0;				// scratch pad var
    cone.valid = true;         // need to be valid to be selected as target
    cone.verified = false;		// Note: must be done at calibration
    cone.locked = true;		// in use, can't be deleted
    cone.fake = true;		// show person outline for calibration
    cone.display = null;		// in use, can't be deleted
    cone.dy = 0;				// to calc when player is at the cone
    cone.show_person = 0;		// show person outline for calibration
    cone.home = false;		    // not home cone
    cone.phantom = false;		// not a phatom marker
    cone.phantom_id = null;	    // no phantom child

    var camera_mode = INFO.cam_ground_mode;

    var orig_cones = CONES.length;
    //if(CONSTS.FAKE_CONE_CONFIG == 4) 
    if(cone_cnt === 4) {
        var top_y, top_x0, top_x1, bot_y, bot_x0, bot_x1;
        switch (camera_mode) {
            case "ground":
                //top_y = height * (2 / 3);      // further cones
                top_y = (INFO.pose_bot) ? (height * (INFO.pose_bot - 8) / 100) : height * (2 / 3);
                top_x0 = width * (1 / 5);
                top_x1 = width * (4 / 5);

                //bot_y = height * (6 / 7);      // closer cones
                bot_y = (INFO.pose_bot) ? (height * (INFO.pose_bot + 8) / 100) : height * (6 / 7);
                bot_x0 = width * (1 / 7);
                bot_x1 = width * (6 / 7);
                break;

            case "tripod":
                //top_y = height * (4 / 6);      // further cones
                top_y = (INFO.pose_bot) ? (height * (INFO.pose_bot - 8) / 100) : height * (4 / 6);
                top_x0 = width * (1 / 3);
                top_x1 = width * (2 / 3);

                //bot_y = height * (8 / 9);      // closer cones
                bot_y = (INFO.pose_bot) ? (height * (INFO.pose_bot + 8) / 100) : height * (8 / 9);
                bot_x0 = width * (1 / 5);
                bot_x1 = width * (4 / 5);
                break;

            case "wall":
                //top_y = height * (4 / 6);      // further cones
                top_y = (INFO.pose_bot) ? (height * (INFO.pose_bot - 8) / 100) : height * (4 / 6);
                top_x0 = width * (1 / 3);
                top_x1 = width * (2 / 3);

                //bot_y = height * (8 / 9);      // closer cones
                bot_y = (INFO.pose_bot) ? (height * (INFO.pose_bot + 8) / 100) : height * (8 / 9);
                bot_x0 = width * (1 / 5);
                bot_x1 = width * (4 / 5);
                break;
        }

        cone1 = {};
        cone.width = cwidth1;
        cone.height = cheight1;
        cone.ctr_x = Math.floor(top_x0);
        cone.ctr_y = Math.floor(top_y);
        cone.id = cone.ctr_x+"-"+cone.ctr_y+"-"+cone.height;		// hash for each find
        //console.log("cone.1326:  B4 FAKE CONES: ", CONES);
        cone1 = {...cone};
        CONES.push(cone1);

        cone.ctr_x = Math.floor(top_x1);
        cone.ctr_y = Math.floor(top_y);
        cone.id = cone.ctr_x+"-"+cone.ctr_y+"-"+cone.height;		// hash for each find
        cone1 = {...cone};
        CONES.push(cone1);

        cone.width = cwidth2;
        cone.height = cheight2;
        cone.ctr_x = Math.floor(bot_x0);
        cone.ctr_y = Math.floor(bot_y);
        cone.id = cone.ctr_x+"-"+cone.ctr_y+"-"+cone.height;		// hash for each find
        cone1 = {...cone};
        CONES.push(cone1);

        cone.ctr_x = Math.floor(bot_x1);
        cone.ctr_y = Math.floor(bot_y);
        cone.id = cone.ctr_x+"-"+cone.ctr_y+"-"+cone.height;		// hash for each find
        cone1 = {...cone};
        CONES.push(cone1);
        //console.log("cone.1336:  # # # # # # #  ADDED 4 FAKE CONES: ", CONES.length, " mode=",camera_mode," mid_y=",mid_y, " pose_bot=",INFO.pose_bot);
    }

    var base_y = (INFO.pose_bot) ? (height * (INFO.pose_bot / 100)) : height;       // pose_bot is a % from adjustCameraAngle()
    base_y = ((height - base_y) < FOOTY) ? (height - FOOTY - 10) : base_y;      // keep it above the screen

    if(cone_cnt === 2) {
        var mid_y, mid_x0, mid_x1;
        var deltax = width * (1 / 11);
        mid_x0 = FOOTX + deltax;
        mid_x1 = width - (FOOTX + deltax);

        // mid cones
        switch (camera_mode) {
            case "ground":
                mid_y = (base_y) ? base_y : height * (1 - (INFO.pose_top / 100));       // pose_top is int_pct
                //mid_y = (base_y) ? base_y : height - INFO.pose_top;       // adjust for "ground view", was 1/2
                //mid_y = (base_y) ? base_y : height * (1 / 2);       // adjust for "ground view"
                //mid_y = (INFO.pose_bot) ? (height * INFO.pose_bot / 100) : height * (1 / 2);       // adjust for "ground view"
                //mid_x0 = width * (1 / 5);   // (1 / 5);
                //mid_x1 = width * (4 / 5);   //(4 / 5);
                break;
            case "tripod":
                mid_y = (base_y) ? base_y : height * (1 - (INFO.pose_top / 100));       // adjust for "ground view", was 1/2
                //mid_y = (base_y) ? base_y : height - INFO.pose_top;       // adjust for "ground view", was 1/2
                //mid_y = (base_y) ? base_y : height * (3 / 4);       // adjust for "ground view"
                //mid_y = height * (3 / 4);
                //mid_y = (INFO.pose_bot) ? (height * INFO.pose_bot / 100) : height * (3 / 4);       // adjust for "ground view"
                //mid_x0 = width * (1 / 5);   // (1 / 5);
                //mid_x1 = width * (4 / 5);   //(4 / 5);
                break;
            case "wall":
                mid_y = (base_y) ? base_y : height * (1 - (INFO.pose_top / 100));       // adjust for "ground view", was 1/2
                //mid_y = (base_y) ? base_y : height - INFO.pose_top;       // adjust for "ground view", was 1/2
                //mid_y = (base_y) ? base_y : height * (3 / 4);       // adjust for "ground view"
                //mid_y = height * (3 / 4);
                //mid_y = (INFO.pose_bot) ? (height * INFO.pose_bot / 100) : height * (3 / 4);       // adjust for "ground view"
                //mid_x0 = width * (1 / 5);   // (1 / 5);
                //mid_x1 = width * (4 / 5);   //(4 / 5);
                break;
        }

        if ((height - mid_y) < cheight1) {
            mid_y = height - cheight1;      // can not be too low
        }

        cone1 = {};
        cone.width = cwidth1;
        cone.height = cheight1;

        cone.ctr_x = Math.floor(mid_x0);
        cone.ctr_y = Math.floor(mid_y);
        cone.id = cone.ctr_x+"-"+cone.ctr_y+"-"+cone.height;		// hash for each find
        cone1 = {...cone};
        CONES.push(cone1);

        cone.ctr_x = Math.floor(mid_x1);
        cone.ctr_y = Math.floor(mid_y);
        cone.id = cone.ctr_x+"-"+cone.ctr_y+"-"+cone.height;		// hash for each find
        cone1 = {...cone};
        CONES.push(cone1);
        console.log("cone.1336:  # # # # # # #  ADDED 2 FAKE CONES: ", CONES.length, " footx=",FOOTX, " deltax=",parseInt(deltax)," height=",height, " cheight1=",cheight1,
                    " ctr_y=",parseInt(mid_y)," base_y=",parseInt(base_y), " mode=",camera_mode, " mid_y=", parseInt(mid_y), " mid_x0=",parseInt(mid_x0), " pose_top=",INFO.pose_top," pose_bot=",INFO.pose_bot, " CONES=",CONES);
    }

    if(cone_cnt === 1) {
        var mid_y, mid_x;
        switch (camera_mode) {
            case "ground":
                //mid_y = height * (1 / 2);       // adjust for "ground view"
                //mid_y = (INFO.pose_bot) ? (height * INFO.pose_bot / 100) : height * (1 / 2);
                //mid_y = (base_y) ? base_y : height - INFO.pose_top;       // adjust for "ground view", was 1/2
                mid_y = (base_y) ? base_y : height * (1 - (INFO.pose_top / 100));       // adjust for "ground view", was 1/2
                mid_x = width * (1 / 4);
                break;
            case "tripod":
                //mid_y = height * (3 / 4);       // adjust for "ground view"
                //mid_y = (INFO.pose_bot) ? (height * INFO.pose_bot / 100) : height * (3 / 4);
                //mid_y = (base_y) ? base_y : height - INFO.pose_top;
                mid_y = (base_y) ? base_y : height * (1 - (INFO.pose_top / 100));       // adjust for "ground view", was 1/2
                mid_x = width * (1 / 4);
                break;
            case "wall":
                //mid_y = height * (3 / 4);       // adjust for "ground view"
                //mid_y = (INFO.pose_bot) ? (height * INFO.pose_bot / 100) : height * (3 / 4);
                //mid_y = (base_y) ? base_y : height - INFO.pose_top;
                mid_y = (base_y) ? base_y : height * (1 - (INFO.pose_top / 100));       // adjust for "ground view", was 1/2
                mid_x = width * (1 / 4);
                break;
            default:
                //mid_y = (base_y) ? base_y : height - INFO.pose_top;
                mid_y = (base_y) ? base_y : height * (1 - (INFO.pose_top / 100));       // adjust for "ground view", was 1/2
                mid_x = width * (1 / 4);
                break;
        }

        if (mid_y > (height - cheight1)) {
            mid_y = height - cheight1;      // can not be too low
        }

        cone1 = {};
        cone.width = cwidth1;
        cone.height = cheight1;

        cone.ctr_x = Math.floor(mid_x);
        cone.ctr_y = Math.floor(mid_y);
        cone.id = cone.ctr_x+"-"+cone.ctr_y+"-"+cone.height;		// hash for each find
        cone1 = {...cone};
        CONES.push(cone1);
        console.log("cone.1336:  # # # # # # #  ADDED 1 FAKE CONES: ", CONES.length, " ctr_x=",mid_x, " ctr_y=",mid_y," base_y=",base_y, " mode=",camera_mode, " pose_bot=",INFO.pose_bot);
    }

    INFO.fake_cones = CONES.length - orig_cones;
    setFrameEvent("CONES");     // debug: turn this off later
}


//
// designate a zone in the center of the cone for player to return
//
export function setPlayerHomeZone() {
	var j = 0, vcnt = 0, x = [], y = [];
	var canvas = INFO.out_canvas;
    var width = (canvas == null) ? 600 : canvas.width;
    var height = (canvas == null) ? 400 : canvas.height;

    if (INFO.home_id !== null) {
        return;     // home is already set!
    }

	// check if there are at least two valid cones
	for(var i = 0; i < CONES.length; i++) {
		var cone1 = CONES[i];
		//if(cone.valid  === true) {
		if((cone1.locked  === true) || (cone1.fake  === true)) {
			vcnt = vcnt + 1;
			x[j] = cone1.ctr_x;
			y[j] = cone1.ctr_y;
			j = j + 1;
		}
	}

	if(vcnt >= 1) {
		// find the max and min of X & Y, keep each pair
		var max_xx = 0, min_xx = 999999, max_xy, min_xy;
		var max_yy = 0, min_yy = 999999, max_yx, min_yx;
		for (var i = 0; i < j; i++) {
			if(x[i] > max_xx) {
				max_xx = x[i];
				max_xy = y[i];
			}
			if(y[i] > max_yy) {
				max_yx = x[i];
				max_yy = y[i];
			}
			if(x[i] < min_xx) {
				min_xx = x[i];
				min_xy = y[i];
			}
			if(y[i] < min_yy) {
				min_yx = x[i];
				min_yy = y[i];
			}
		}

        if(max_yy === min_yy) {
            min_yy = min_yy - CONSTS.HOME_MIN_YOFFSET;  // move it back for 2-cone config
        }

		//var mid_x = (max_xx + min_xx) / 2;
		//var mid_x = ((max_xx - min_xx) / 2) + min_xx;      // half the delta to get to middle
		var mid_x = width / 2;     // KLUDGE: middle of the screen
		var mid_y = ((max_yy - min_yy) / 2) + min_yy;      // adjust for "ground view"
		console.log("home.1091: **** SET HOMING ZONE: x=",mid_x, " y=", mid_y, "  CONES=", CONES);
		console.log("home.1092:                  max_xx=",max_xx, " max_xy=", max_xy, " max_yy=",max_yy, " max_yx=", max_yx);
		console.log("home.1093:                  min_xx=",min_xx, " min_xy=", min_xy, " min_yy=",min_yy, " min_yx=", min_yx);
		INFO.home_xsize = CONSTS.HOME_XSIZE;    // 35;
		INFO.home_ysize = CONSTS.HOME_YSIZE;    // 18;

		var x = mid_x;
		var y = mid_y;
		INFO.home_x = x;
		INFO.home_y = y;

        var cone = {};      // needed a fresh one to avoid weird probs!
        cone.ctr_x = x;
        cone.ctr_y = y;
        cone.locked = true;
        cone.home = true;
        cone.fake = true;
        cone.name = CONSTS.HOME_SPECIAL_ID+"-"+cone.ctr_x+"-"+cone.ctr_y;
        cone.id = CONSTS.HOME_SPECIAL_ID+"-"+cone.ctr_x+"-"+cone.ctr_y;
        //cone.valid = false;     // avoid normal processing
        cone.valid = true; 
        cone.verified = true; 
        cone.phantom = false;

        CONES.push(cone);
        INFO.home_id = cone.id;
		console.log("home.211: **** HOME CONE SET: idx=", INFO.home_id, "  cone=",cone, "  CONES=",CONES);

		//INFO.perf_running = true;	// start the performance trial when get to the home pad
        playAudio(CONSTS.MINOR_PROGRESS_PATH, "has_home.404");         // reached home zone - ready to start

	} else {
        resetCalibration();
        INFO.home_id = null;
		INFO.home_x = 0;
		INFO.home_y = 0;
        INFO.target_idx = null;
		console.log("home.79: **** ERROR:  NOT ENOUGH CONES! got", vcnt, "  cones=",CONES);
	}

    /*/ debug only, weird racing cond
	for(var i = 0; i < CONES.length; i++) {
		var cone = CONES[i];
        console.log("home.375: DUMP  i=",i, "  home=",cone.home, " c.x=", cone.ctr_x, " c.y=", cone.ctr_y);
    }
    */
}


// START SEQUENCE:  calibrate cone(s), go to home zone, session starts
// STOP SEQUENCE:   stand at home zone, ring turn red,  session stops
// see if player is standing by a cone, if so, take femur measurement
// record the typical height delta for this player, turn home ring green
export async function checkSessionCalibration() {
	var hidx = HISTORY.length - 1;
	var f0 = HISTORY[hidx];
    if (f0 === undefined) { return; }

	var pose = f0.pose;
	var stats = f0.stats;

	if((INFO.has_calibration === true) || (INFO.disable_calibration  === true) || (INFO.cancel_cnt > 0) ||
       (HISTORY.length < 3) || (CONES.length === 0)) {
		//console.log("calib.437:    ! ! ! ! ! ! !   SKIP CALIB CHECK:  has_calib=",INFO.has_calibration, " disable_calib=",INFO.disable_calibration,"  cancel_cnt=",INFO.cancel_cnt, " CONES.len=",CONES);
		return;
	}

    if ((pose.has_head === false) || (pose.has_feet === false)) { 
        // failed, we need to see whole body to calibrate properly
        //      - NOTE: consider camera is in ground view
        //
        //console.log("calib.394:    ! ! ! ! ! !  ADJUST CAMERA NEEDED   pose.valid=",pose.valid," eyes_prob",pose.eyes_prob, " head_prob=",pose.head_prob, " ank_prob=",pose.ank_prob);
        INFO.notify_messages = [];
        INFO.notify_messages.push(" ");
        INFO.notify_messages.push("PRESENT ENTIRE BODY");
        INFO.notify_color = "yellow";
        INFO.notify_size = 25;
        TIMES.timer_stop_display = Date.now() + CONSTS.CONES_RESULT_ERROR_MSDELAY;
        //timerDisplayResult("Sess.Calib.468");
    }


	for(var i = 0; i < CONES.length; i++) {
		var CONE = CONES[i];
		if ((pose.valid  === true) && (CONE.valid  === true)) {

			var dx = Math.abs(CONE.ctr_x - pose.ctr_x);
            //console.log("calib.458:            . . .  CALIB   ",i,":  id=",CONE.id, " pose.valid=",pose.valid, " CONE.valid=",CONE.valid, "CONE.target=",CONE.target, " p.ctr_x=",pose.ctr_x, "c.ctr_x=",CONE.ctr_x," dx=",dx);
			if ((CONE.target === true) && (pose.ctr_x > 0)) {
            
				//console.log("calib.478:  ***     PRE-CALIB  CONE.id=",CONE.id, " hidx=",hidx, "  dx=",Math.floor(dx), "  scale_x=", INFO.scale_x, "  DY=",Math.floor(CONE.dy), "  c.x=", CONE.ctr_x, " c.y=",CONE.ctr_y, " p.x=", pose.ctr_x, " p.y=", pose.ctr_y, " veri_cnt=",CONE.veri_cnt);
                if (dx < (CONSTS.CONES_VERIFY_DELTA_X * INFO.scale_x)) {

                    // Player arrived at Calibration cone
                    //
                    var dy = CONE.ctr_y - pose.ctr_y;
                    CONE.dy = Math.floor((CONSTS.EXPON_CONE_DY * dy) + ((1 - CONSTS.EXPON_CONE_DY) * CONE.dy));	// body above the cone
                    CONE.veri_cnt = CONE.veri_cnt + 1;

                    if (CONE.veri_cnt > CONSTS.CONES_VERIFY_THRESHOLD) {
                        //console.log("calib.262:     # # # # #   HAS CALIB   CONE.id=",CONE.id, " hidx=",hidx, "  DY=",Math.floor(CONE.dy), "  c.x=", CONE.ctr_x, " c.y=",CONE.ctr_y, " p.x=", pose.ctr_x, " p.y=", pose.ctr_y, " veri_cnt=",CONE.veri_cnt, " verified=",CONE.verified, " calib_cnt=",INFO.calibrate_cnt);

                        // we have calibration if enough times
                        //
                        INFO.notify_messages = [];
                        TIMES.timer_stop_display = 0;
                        // standing awhile at a cone will toggle verify state
                        if (CONE.verified === false) {
                            // add new verify
                            CONE.verified = true;
                            CONE.veri_cnt = -30;	// to prevent rapid toggle
                            INFO.cone_dy = CONE.dy;
                            INFO.cone_y = CONE.ctr_y;
                            INFO.calibrate_cnt = INFO.calibrate_cnt + 1;
                            if(INFO.calibrate_cnt >= CONSTS.CALIBRATION_CONE_NEED) {
                                INFO.has_calibration = true;
                                INFO.gesture_allowed = false;       // KLUDGE: do it more central?

                                console.log("calib.295:  *** CALIBRATION COMPLETE   CONE[",i,"].",CONE.id,"   DY=",dy, "  @Y=",CONE.ctr_y,  " c.x=", CONE.ctr_x, " cancel_cnt=",INFO.cancel_cnt);
                                lockCones(true);        // lock and filter cones before setting the home zone
                                setPlayerHomeZone();
                                prepareCones();            // this is used to calc "goal reached zone"
                                TIMES.timer_restart_cooldown = 0;   // ready to start

                                // PRACTICE MODE: *** Start timing once we detected a "turn anchor"
                                if(INFO.practice_mode  === true) {
                                    //resetSession();
                                    INFO.practice_start_x = pose.ctr_x;      // starting poisition
                                    INFO.practice_start_y = pose.ctr_y;
                                    startRun();    // TIME START IN calcPraciceRep()
                                    var t0 = Date.now();
                                    TIMES.player_moving = t0;	// after signal, time to move from zero to something
                                    TIMES.start_phantom = t0;	// start of the phantom signal (redirection after initial target)
                                    //TIMES.phantom_moving = t0;	// after signal, time to move from zero to something
                                    INFO.show_cones = false;

                                    INFO.notify_messages = [];      // KLUDGE: This should be init earlier

                                    INFO.notify_title = "PROCEED";
                                    INFO.notify_size = 40;
                                    TIMES.timer_stop_display = Date.now() + CONSTS.CONES_RESULT_PROCEED_MSDELAY;
                                    //timerDisplayResult("Has.Calib.508");
                                }
                                CONE.target = false;        // turn off calibration target
                            }
                        } else {
                            /* if already verified, unverify it....Note: No need for this
                            CONE.verified = false;
                            CONE.veri_cnt = 0;	// to prevent toggle    // -30
                            CONE.locked = false;
                            INFO.cone_dy = 0;
                            INFO.cone_y = 0;*/
                            console.log("calib.380:  *** REMOVE CALIBRATION   CONE["+i+"].",CONE.id,"   DY=",dy, "  @Y=",CONE.ctr_y,  " c.x=", CONE.ctr_x);
                        }

                        //CONE.target = false;
                        setFrameEvent("CALIB");

                    }   // if (CONE.veri_cnt > CONSTS.CONES_VERIFY_THRESHOLD) 

                }   // if (dx < (CONSTS.CONES_VERIFY_DELTA_X * INFO.scale_x))


            } else {
                //console.log("calib.260:          . . . BAD dx=",dx, " max_dx=", CONSTS.CONES_VERIFY_DELTA_X, " veri_cnt=",CONE.veri_cnt);
                CONE.veri_cnt = (CONE.veri_cnt < 0) ? 0 : CONE.veri_cnt - 1;		// reset, need to be consequtive
            }

        }   // if ((pose.valid  === true) && (CONE.valid  === true))

	}   // for (var i = 0; i < CONES.length; i++)
}


// prepare cones for session, lock all valid and verified ones so they can't be deleted
// during a run, also add label-ID for ease of analysis, make sure all cone has dy
export function lockCones(lock) {
    var cone;

    if(lock  === true) {
        var tids = filterCones(INFO.show_virtual_cones_only);    // returns cone.id because index is not reliable
        for(var i = 0; i < CONES.length; i++) {
            cone = CONES[i];
            cone.locked = false;        // unlock all
            cone.verified = false; 

            for(var j=0; j< tids.length; j++) {
                var tid = tids[i]; // lock those filtered and identified
                if (cone.id === tid) {
                    //console.log("lock.318: locking cone ", cone.id, " tids=",tids);
                    cone.locked = true;        // lock
                    cone.verified = true; 
                }
            }

            cone.used = 0;          // clear it each time, usage cnt for random select
            cone.veri_cnt = 0; 
            cone.display = null; 
        }
    } else {
        console.log("unlock_cone.454:   UNLOCK START ",CONES);
        for(var i = (CONES.length - 1); i >= 0; i--) {
            cone = CONES[i];
            cone.locked = false;        // unlock all
            cone.verified = false; 
            if(cone.fake  === true) {
                var removed = CONES.splice(i, 1);      // remove all fake cones
                console.log("unlock_cone.458:  REMOVED.",cone.id," ",i, "   ", removed, "  LEFT=",CONES);
            } else {
                console.log("unlock_cone.462: xxxxx NOT REMOVED.",cone.id," ",i, "   ", "  cone=",CONES);
            }
        }
    }
}



// go through all cones and weed out non-qualified cones
//   - get rid of dup cones 
//   - cones too far away from the cluster
//   - cones at edge of screen
//
export function filterCones(virtual_only) {
    var cone, c1, c2, dist, dists = [], avg = [], dist_sum = 0, dist_avg = 0, vcnt = 0, ncnt;
    var tids= []
    var ww = INFO.image_width;
    var hh = INFO.image_height;

    if (virtual_only === true) {
        for(var i = 0; i < CONES.length; i++) {
            var c0 = CONES[i];
            tids.push(c0.id);
        }
        return tids;
    }


    for(var i = 0; i < CONES.length; i++) {
        c1 = CONES[i];
        if ((c1.valid === false) || (c1.phantom  === true)) {
            dists[i] = 0;
            //console.log("lock.156:  C1 INVALID SKIP cone[",i,"]."+c1.id+"   distance sum = ", dists[i]);
            continue;
        }

        dists[i] = 0;
        ncnt = 0;
        for(var j = 0; j < CONES.length; j++) {
            c2=CONES[j];
            if ((c2.valid === false) || (j === i)) {
                continue;
            }
            dist = calcDistance(null, c1.ctr_x, c2.ctr_x, c1.ctr_y, c2.ctr_y);
            if ((dist < CONSTS.CONE_MIN_INTER_DISTANCE) && (c2.locked = false)) {
                // eliminate cone that is too close likely dups
                console.log("lock.168:  ELIMINATED DUP cone[",j,"]."+c2.id+" TOO NEAR TO ",i,"."+c1.id+ "   distance sum = ", dist);
                c2.valid = false;
            } else {
                ncnt = ncnt + 1;
                dists[i] = dists[i] + dist;
                //console.log("lock.172:            cone[",i,"].",c1.id," => ",j, "    adding ",dist, "   sum=", dists[i]);
            }
        }
        avg[i] = dists[i] / ncnt;
        dist_sum = dist_sum + avg[i];
        vcnt = vcnt + 1;
        //console.log("lock.176:  cone[",i,"].",c1.id,"  avg=",avg[i], "   sum = ", dists[i]);

        // valid target cones can't be too close to screen edges, unable to reliably detect pose
        var topy = hh *CONSTS.CONE_IMAGE_TOP_MARGINY_PCT;
        var boty = hh *CONSTS.CONE_IMAGE_BOT_MARGINY_PCT;
        var sidex = ww *CONSTS.CONE_IMAGE_MARGINX_PCT;
        if(c1.ctr_y > (boty) || (c1.ctr_y < topy)) {
            //console.log("lock.389:  REMOVE CONE FOR Y:  cone[",i,"].",c1.id,"  y=",c1.ctr_y, " top=", topy, "  bot=",(boty));
            c1.valid = false;
        }
        if(c1.ctr_x > (ww - sidex) || (c1.ctr_x < sidex)) {
            //console.log("lock.393:  REMOVE CONE FOR X:  cone[",i,"].",c1.id,"  x=",c1.ctr_x, " left=", sidex, "  right=",(ww-sidex));
            c1.valid = false;
        }
    }
    dist_avg = dist_sum / (vcnt);
    //console.log("lock.131:  cone distance max_avg = ", (dist_avg * CONSTS.CONE_MAX_DISTANCE_FACTOR), " cones=",CONES);

    // eliminate cones too far from the group
    for(var i = 0; i < CONES.length; i++) {
        cone = CONES[i];
        //if ((cone.valid === false) || (cone.phantom  === true)) {
        if (((cone.valid === false) && (cone.fake === false)) ||  (cone.phantom  === true)) {
            continue;
        }
        // if more than 3 cones, only lock the valid ones and nothing too high
        if ((CONES.length < 4) || (avg[i] < (dist_avg * CONSTS.CONE_MAX_DISTANCE_FACTOR))) {
            //if ((cone.valid  === true) || (cone.verified  === true)) {
            if (((cone.fake  === true) && (cone.home === false)) || (cone.valid  === true) || (cone.verified  === true)) {
                //cone.locked = true; 
                //cone.verified = true; 
                tids.push(cone.id);
            }
        } else {
            cone.valid = false;
            //console.log("lock.191:  FAR  ",i,".",cone.id,"  avg=", avg[i], "  c.valid=",cone.valid, "  c.verify=",cone.verified, "  CONES=",CONES.length,
            //            " max_avg = ", (dist_avg * CONSTS.CONE_MAX_DISTANCE_FACTOR), " cones=",CONES);
        }
    }

    //console.log("filter.581:  retrurn=",tids);
    return tids;
}

function isConeValid(id, tids) {
    var valid = false;
    for(var j=0; j< tids.length; j++) {
        var tid = tids[j]; // lock those filtered and identified
        if (id === tid) {
            //console.log("isvalid.464: found ", cone.id, " tids=",tids);
            valid = true;
        }
    }
    return valid;
}

// compare by id and return index
function getConeByID(id, cones) {
    var idx = -1;
    for(var j=0; j< cones.length; j++) {
        var cone = cones[j]; // lock those filtered and identified
        if (id === cone.id) {
            idx = j;
            //console.log("coneID.478: found ", cone.id, " idx=",idx);
            break;
        }
    }

    return idx;
}



// assign names to degrees to HOME, seed DY from calibrated cones
// add invisible photom cones, these are used to cause mis-course reverse
//
var p1console_log = (false) ? () => {} : console.log;		// true will disable console.log

export function addPhantomCones() {
    var y=[], dy=[], max_y=0, min_y=9999999, max_dy, min_dy, dydy, valid, cone;
    var idx = getConeByID(INFO.home_id, CONES);
    var h = CONES[idx];
    if (h === undefined) {
        console.log("prep.374:  Home not defined!  idx=", INFO.home_id, CONES);
        return;
    }

    // insert phantom cones for each target to support mid-course reversal
    //
    var tids = filterCones(INFO.show_virtual_cones_only);    // returns cone.id because index is not reliable
    p1console_log("phantom.747:    # # # # # # # CREATED PHANTOM   tids=", tids.length, "  CONES=", CONES.length);
    for(var i = 0; i < CONES.length; i++) {
        cone = CONES[i];
        valid = isConeValid(cone.id, tids);

        if ((valid  === true) && (cone.phantom === false) && (!cone.phantom_id) && (cone.home === false)) {
            var ncone = CloneObject(ConeObj);
            //var ncone = {}  // KLUDGE: TEST ONLY!!

            ncone.valid = true;     // enable this base on run mode

            var min_xx = (h.ctr_x > cone.ctr_x) ? cone.ctr_x : h.ctr_x;
            var max_xx = (h.ctr_x < cone.ctr_x) ? cone.ctr_x : h.ctr_x;
            var min_yy = (h.ctr_y > cone.ctr_y) ? cone.ctr_y : h.ctr_y;
            var max_yy = (h.ctr_y < cone.ctr_y) ? cone.ctr_y : h.ctr_y;

            if (false) {    // old ratio code, replace with femur x
                var xratio = (h.ctr_x < cone.ctr_x) ? CONSTS.CONE_PHANTOM_DIST_PCT : (1 - CONSTS.CONE_PHANTOM_DIST_PCT);        // not symetrical
                var yratio = (h.ctr_y < cone.ctr_y) ? CONSTS.CONE_PHANTOM_DIST_PCT : (1 - CONSTS.CONE_PHANTOM_DIST_PCT);        // not symetrical
                ncone.ctr_x = Math.floor(((max_xx - min_xx) * xratio) + min_xx);
                ncone.ctr_y = Math.floor(((max_yy - min_yy) * yratio) + min_yy);
            }

            // Estimate femur distance coord
            //   d^2 = x^2 + y^2
            //   x = sqrt(d^2 - y^2)   <<< assume y is halfway (?)
            //
            // Note: phantom cones should be set once reached home
            //
            var femur = (INFO.femur_home_px) ? INFO.femur_home_px : INFO.femur_px;
            var fdy = ((max_yy - min_yy) * 0.5);
            var fdx = Math.sqrt((femur * femur) - (fdy * fdy));
            ncone.ctr_x = fdx + min_xx + 1;     // extra offset to make sure react is registered b4 phantom
            ncone.ctr_y = fdy + min_yy + 1;
            var dd = Math.sqrt((fdx * fdx) + (fdy *fdy))
            console.log("phantom.224:   =======>  PHANTOM DIST CALC       dx=",parseInt(fdx), "  dy=",parseInt(fdy),"  dd=",parseInt(dd), "   x=",ncone.ctr_x," y=",ncone.ctr_y, " femur=",femur);

            ncone.width = 11;   // unique code
            ncone.height = 11;
            ncone.fake = true;
            ncone.locked = true;
            ncone.phantom = true;
            ncone.phantom_id = null;
            ncone.valid_cnt = 100;
            ncone.id = "P"+ncone.ctr_x+"-"+ncone.ctr_y+"-"+ncone.height;		// hash for each find
            //ncone.name = "P"+cone.name;       // gets overwritten below
            CONES.push(ncone);

            CONES[i].phantom_id = ncone.id;    // link to parent, use this to check
            p1console_log("phantom.512:             . . . ",i, ":   ADD PHANTOM  ", ncone.id, " for ",cone.id, "  ", ncone);
        }

        if (CONES.length > 20){return}      // DEBUG: break infinite loop
    }
}




export function prepareCones() {
    var y=[], dy=[], max_y=0, min_y=9999999, max_dy, min_dy, dydy, valid, cone;
    var idx = getConeByID(INFO.home_id, CONES);
    var h = CONES[idx];
    if (h === undefined) {
        console.log("prep.374:  Home not defined!  idx=", INFO.home_id, CONES);
        return;
    }


    // extract reliable DY data from multiple cones and assign names
    for(var i = 0; i < CONES.length; i++) {
        var cone = CONES[i];
        // extract calibrated DY, this determines the "strike zone" at mid-body
        if ((cone.dy !== undefined) && (cone.dy > 0)) {
            // remember for later to populate all other dy
            var cy = cone.ctr_y;
            y.push(cy);
            dy.push(cone.dy);
            //p1console_log("dy.362: INIT.DY  i=",i, "  DY=",cone.dy, "  Y=",cone.ctr_y, " cone=", CONES[i]);
            if(cy > max_y) {
                max_y = cy;
                max_dy = cone.dy;
            }
            if(cy < min_y) {
                min_y = cy;
                min_dy = cone.dy;
            }
        }

        // assign names based on direction degree
        //p1console_log("dump.375: DUMP  i=",i, "  home=",cone.home, "  nm=",cone.name, " c.x=", cone.ctr_x, " c.y=", cone.ctr_y);
        if (cone.home === false) {
            var degree = calcDegree(null, h.ctr_x, cone.ctr_x, h.ctr_y, cone.ctr_y);
            cone.name = degree - (degree % 10);      // for graph label, round it to 10 degrees
            if(cone.phantom  === true) {
                cone.name = "P"+cone.name;
            }
            //p1console_log("cone.377:  NAMING i=", i, "  degree=", cone.name);
        } else {
            //p1console_log("cone.380:  NAMING i=", i, "  HOME");
        }
    }

    if(max_y === min_y) {
        dydy = (10) / (20);     // Need to estimate
    } else {
        dydy = (max_dy - min_dy) / (max_y - min_y);     // Y scale factor
    }
    //p1console_log("dy.499:    ESTIMATE dydy=", dydy, " max_dy=",max_dy, " min_dy=",min_dy, " max_y=",max_y, " min_y=",min_y);

    // populate dy in cones without one, use linear extrapolation
    //
    var goals = 0;
    for(var i = 0; i < CONES.length; i++) {
        var cone = CONES[i];
        if(cone.dy > 0) {
            //p1console_log("dy.371: ******* REF.DY["+i+"].",cone.name,"  dydy=",dydy,"  c.dy=",cone.dy, "  c.y=",cone.ctr_y, " cone=",CONES[i]);
            continue;
        }

        var y = cone.ctr_y;
        cone.dy = Math.floor(((y - min_y) * dydy) + min_dy);      // linear scaled
        //p1console_log("dy.369: ******* CONE["+i+"].",cone.name, " dy=",cone.dy, " y=", cone.ctr_y,"  cone=",CONES[i]);

        if ((cone.locked  === true) && ((cone.valid  === true) || (cone.verfied  === true))) {
            goals = goals + 1;
        }

        // other cone initiazation
        //
        cone.display = null;
    }
    INFO.active_goals = goals;
    //p1console_log("dy.514:  AFTER DY PREP: ", CONES);
}



// figure out when to do advanced reverse
//
var REPEAT_SWITCH_CNT = 0;
var REPEAT_NO_SWITCH_CNT = 0;
export function determineReverse() {
    var hidx = HISTORY.length - 1;
    var random = pickRandomIndex(4);
    var doswitch =  ((random % 2) === 1) ? true : false;
    //var random = Math.random();
    //var doswitch =  ((random > 0.5)) ? true : false;
    if(REPEAT_SWITCH_CNT > 2) {
        doswitch = false;
    }
    if(REPEAT_NO_SWITCH_CNT > 1) {
        doswitch = true;
    }

    console.log("reverse.740:  ........... RANDOM  hidx=", hidx, "  doswitch=", doswitch, " REPEAT_NO_SWITCH_CNT=", REPEAT_NO_SWITCH_CNT, " REPEAT_SWITCH_CNT=", REPEAT_SWITCH_CNT);
    if(doswitch  === true) {
        REPEAT_SWITCH_CNT = REPEAT_SWITCH_CNT + 1;
        REPEAT_NO_SWITCH_CNT = 0;
    } else {
        REPEAT_SWITCH_CNT = 0;
        REPEAT_NO_SWITCH_CNT = REPEAT_NO_SWITCH_CNT + 1; 
    }
    return doswitch;       // simple 50%
}


// decide if it's time to do advanced reverse
//   - use run count as basis, more reliable
//   - do not do back to back
//   - space it out to keep player guessing (once every third?)
//   - fixed numb per run, so total timing between players can compare
export function oldDetermineReverse() {
    var hidx = HISTORY.length - 1;
    var run = INFO.rep_run_cnt;
    if(LAST_PHANTOM_RUN === run) {
        //console.log("reverse.618:                         SAME RUN!   @run=", run, " hidx=",hidx)
        return false;
    }

    if(LAST_PHANTOM_RUN === (run - 1)) {
        //console.log("reverse.616:                       LAST ONE WAS REVERSE  @run=", run," hidx=",hidx)
        return false;
    }

    var doPhantom = (pickRandomIndex(5) > 1) ? true : false;       // 
    //console.log("reverse.616:                          DECIDING RANDOM REVERSE = ", doPhantom, "  @run=",run, " hidx=",hidx);
    if (doPhantom  === true) {
        LAST_PHANTOM_RUN = INFO.rep_run_cnt;
        return true;
    }
    return false;
}


// determine the next target, randomly or based on pre-set program
//     - do not pick Home
//
var LAST_CONE_USED = 0;
var REPEAT_CONES_CNT = 0;
var LAST_PHANTOM_RUN = -1;
var tconsole_log = (false) ? () => {} : console.log;		// true will disable console.log
export function findNextTarget(no_repeat) {
    var hidx = HISTORY.length - 1;
    var cone, gidx = [], out_idx=null;

    for(var i = 0; i < CONES.length; i++) {
        cone = CONES[i];
        cone.display = null;    // init, nothing is targeted
        if ((cone.home === false) && (cone.phantom === false) && (cone.locked  === true) && ((cone.valid  === true) || (cone.verified  === true))) {
            gidx.push(i);       // select from among qualified
        }
        //console.log("target.774:             . . . ",i,":     ",cone.id, " locked",cone.locked," phantom=", cone.phantom, " phantom_id=",cone.phantom_id," valid=",cone.valid, "  verify=",cone.verified);
    }

    if (gidx.length === 0) {
        console.error("target.928:     ! ! ! ! ! ! ! !   NO TARGET CONE SELECTED  CONES.len=",CONES.length, CONES);
        return;     // no eligible cones
    }

    var random = pickRandomIndex(gidx.length);
    var tcone = CONES[gidx[random]];
    if(INFO.no_ai_mode === false)
        tconsole_log("target.614:   ======>  TARGET: CONE SELECTED  hidx=",hidx, " random=",random, ".",tcone.id, "  ctr_x=", tcone.ctr_x, 
                    " ctr_y=",tcone.ctr_y,"  gidx=",gidx[random], " / ", gidx.length, " REPEAT_CNT=",REPEAT_CONES_CNT);

    var min_cnt = 9999999;
    var tidx = null;
    if (no_repeat  === true) {
        for(var i = 0; i < gidx.length; i++) {
            var idx = gidx[i];
            if(idx !== LAST_CONE_USED) {
                out_idx = i;
                break;
            }
        }
        tconsole_log("target.827:  =======>  TARGET: NOT REPEAT, SWITCH TO OTHER CONE  out_idx=",out_idx);
    } else {
        // allows repeat, diff mode for two cone vs. multi-cone, want enough perceived variation
        //
        if (INFO.active_goals <= 2) {
            // two cones mode
            out_idx = gidx[random];
            if ((out_idx === LAST_CONE_USED) && (REPEAT_CONES_CNT > 1)) {
                // max of 3 repeats
                for(var i = 0; i < gidx.length; i++) {
                    var idx = gidx[i];
                    if (idx !== LAST_CONE_USED) {
                        out_idx = idx;      // switch to the other one
                        break;
                    }
                }
            }
            //tconsole_log("pick_target.844:  REPEAT=",REPEAT_CONES_CNT,"  out_idx=",out_idx);
        } else {
            // multi-cones, adjust the amount of repeats
            var pickLeastUsed = (pickRandomIndex(3) === 1) ? true : false;       // 33% to equalized
            //if ((INFO.active_goals > 2) && (gidx[random] == LAST_CONE_USED) || (pickLeastUsed  === true)) 
            if ((gidx[random] === LAST_CONE_USED) || (pickLeastUsed  === true)) {
                // if has enuf cones, avoid repeating the same one, draw from least used if random fn is not random
                //
                for(var i = 0; i < gidx.length; i++) {
                    var idx = gidx[i];
                    if(CONES[idx].used < min_cnt) {
                        tidx = i;
                        min_cnt = CONES[idx].used;
                    }
                }
                out_idx = tidx;
            } else {
                out_idx = gidx[random];
            }
        }
    }

    // KLUDGE!
    if (no_repeat === false) {   // MEGA KLUDGE: Need to special case Advance Switch, no_repeat is not reliable!
        if (out_idx === LAST_CONE_USED) {
            REPEAT_CONES_CNT = REPEAT_CONES_CNT + 1;
        } else {
            REPEAT_CONES_CNT = 0;
        }
        LAST_CONE_USED = out_idx;
    }

    INFO.phantom_reacted = false;        // is this best place to reset it?
    INFO.phantom_reached = false;
    if(CONES[out_idx] !== undefined) {
        CONES[out_idx].used = CONES[out_idx].used + 1;
    }
    return out_idx;
}



// start of a run / rep, a session can have many runs
//
export function startRun() {
    var cone_idx, start_time = 0;
    var hidx = HISTORY.length - 1;

        TIMES.player_moving = 0;       // reset to get a new read
        INFO.target_start_dist = 0;
        INFO.target_reacted = false;

		INFO.timer_display = "";
		INFO.ptimer_display = "";
		TIMES.timer_stop_display = 0;

        TIMES.session_start = Date.now();       // KLUDGE: FOR SAVING TO BUCKET FOR NOW
        console.log("startrun.574: ", CONES);
        start_time = Date.now();
        if(INFO.practice_mode === true) {
            INFO.reps_running = true;
            setFrameEvent("START-PRACTICE");

        } else if (INFO.defender_mode === true) {
            INFO.defender_running = true;
            INFO.perf_running = true;           // KLUDGE: NEED TO CLEAN THIS UP
            INFO.reps_running = true;

            INFO.show_defender = true;
            INFO.show_home_zone = false;
            TIMES.reached_2femur = 0;       // reset to get a new read

            INFO.defend_tot_turns = 0;
            INFO.defend_gave_up = false;
            INFO.defend_max_dx_psec = null;            // max pixel movement per second, normalized with femur (~200)
            INFO.defend_restart_time = null;           // time with cognition delay

            lockCones(true);        // lock and filter cones before setting the home zone
            setFrameEvent("START"+INFO.rep_run_cnt+"-"+hidx);

        } else if (INFO.perf_mode === true) {
            INFO.perf_running = true;
            INFO.reps_running = true;

            TIMES.start_phantom = 0;       // reset to get a new read
            TIMES.phantom_moving = 0;       // reset to get a new read
            INFO.phantom_running = false;
            INFO.phantom_reacted = false;
            INFO.phantom_reached = false;

            // REGULAR CHALLENGE 2-CONE MODE
            lockCones(true);        // lock and filter cones before setting the home zone
            prepareCones();            // this is used to calc "goal reached zone"

            cone_idx = findNextTarget(false);
            start_time = signalPlayer(cone_idx);
            var name = (CONES[cone_idx] === undefined) ? "none" : CONES[cone_idx].name;
            //setFrameEvent("START"+INFO.rep_run_cnt+"-"+CONES[INFO.target_idx].name);
            setFrameEvent("START"+INFO.rep_run_cnt+"-"+name);
        }

        TIMES.start_run = start_time;
        TIMES.start_timer_run = start_time;     // for duration based runs

        return start_time;
}




// MERGE REJECTED PTURNS INTO PREVIOUS
//      - merge it with previous to make it longer
//      - give top level another chance to detect turn with longer dist
//      - Each PTURN has the most current X and degree that goes to it
//
export function compressTurns() {
    var pidx = PTURNS.length - 1;
    var pidx1 = pidx - 1;
    var pidx2 = pidx - 2;
    var pturn = PTURNS[pidx];
    var pturn1 = PTURNS[pidx1];
    var pturn2 = PTURNS[pidx2];
    if (!pturn2) return;
    //console.log("compress.1066:        COMPRESS   PTURNS[",pidx,"] hidx=",pturn.hidx, " reject=",pturn.reject,"       x=",pturn.x,"       degree=",pturn.degree)

    //var zone = degreeZone(pturn.degree);
    //var zone1 = degreeZone(pturn1.degree);
    //if (zone === zone1) {
    if (pturn1.reject === true) {
        // both turns are the same, merge new one back to old one
        var ptotdegree = calcDegree(null, pturn.x, pturn2.x, pturn.y, pturn2.y);
        var ptotdist = calcDistance(null, pturn.x, pturn2.x, pturn.y, pturn2.y);

        PTURNS[pidx -1].dtime = pturn.dtime + pturn1.dtime;				// delta msec from last turn
        //PTURNS[pidx -1].x = pturn2.x;
        //PTURNS[pidx -1].y = pturn2.y;
        PTURNS[pidx].x = pturn.x;        // keep the most current X
        PTURNS[pidx].y = pturn.y;
        PTURNS[pidx].degree = Math.floor(ptotdegree)
        PTURNS[pidx].ddegree = Math.floor(ptotdegree - pturn2.degree);			// change in degree from last turn
        PTURNS[pidx].dist = Math.floor(ptotdist)        // / pcnt);		// pix distance traveled since last turn
        PTURNS[pidx1].hidx = pturn.hidx;

        PTURNS.slice(0, -1);       // remove last element
        console.log("compress.1066:        # # # # #  PTURNS[",pidx,"] new.PTURNS.len=",PTURNS.length,"  MERGED   hidx=",pturn.hidx, "t.hidx=",pturn2.hidx, "  x=",pturn1.x, " x2=",pturn2.x,"  n.degree=",pturn1.degree, " n.dist=",pturn1.dist, " n.dtime=",pturn1.dtime)
    } 


    /*
    for(var i = pidx; i < PTURNS.length; i++) {
        var pturn = PTURNS[i];
        var zone = degreeZone(pturn.degree);
        if (zone === last_zone) {
            // both turns are the same, merge new one back to old one

        } else {
            last_zone = zone;
        }
    }
    */
}





// Merge ball turns with pose turns?   huh?
//
function mergeTurns() {
    var out = [];
    if(PTURNS.length === 0) {
        return [];
    }

    if(BTURNS.length === 0) {
        console.log("merge.1108:  # # # # # # MERGED TURNS  ===> ONLY PTURNS=",PTURNS)
        return PTURNS;
    }
    var TURNS1 = (PTURNS[0].timestamp < BTURNS[0].timestamp) ? PTURNS : BTURNS;
    var TURNS2 = (PTURNS[0].timestamp < BTURNS[0].timestamp) ? BTURNS : PTURNS;

    var t2 = 0;
    for(var i = 0; i < TURNS1.length; i++) {
        var turn1 = TURNS1[i];
        if ((t2 === TURNS2.length)  || (turn1.timestamp < TURNS2[t2].timestamp)) {
            out = out.concat(TURNS1[i]);
            console.log("merge.747:  TURN1["+i+"]=", JSON.stringify(TURNS1[i]));
        } else {
            for(var j = t2; j < TURNS2.length; j++) {
                var turn2 = TURNS2[j];
                if (turn2.timestamp < turn1.timestamp) {
                    out = out.concat(TURNS2[j]);
                    t2 = t2 + 1;
                    console.log("merge.753:  TURN2["+j+"]=", JSON.stringify(TURNS2[j]));
                }
            }
        }
    }
    console.log("merge.764:  # # # # # # MERGED TURNS   out=",out)
    return out;
}



// end of run, set it up for the next one
//
export function stopRun(save_mode, from) {
    var mode = null, start_run = null;
    var tcone = CONES[INFO.target_idx];
    //console.log("time.835:  finish time = ", Math.floor(time))
    INFO.display_rep_cnt = "";
    INFO.rep_run_cnt = INFO.rep_run_cnt + 1;
    console.log("run.75:   +++++++++ STOP RUN ++++++++   from=",from, " save_mode=", save_mode, " rep_cnt=",INFO.rep_run_cnt, " tot_rep=",INFO.drill_tot_rep_cnt);

    if (INFO.defender_mode === true) {
        mode = "defender";
        start_run = (TIMES.reached_2femur < TIMES.start_run) ? TIMES.start_run0 : TIMES.start_run;		// start of the signal

        INFO.beat_defender = false;       // access gaveup
        TIMES.reached_2femur = 0;       // reset to get a new read
        if (save_mode === false) { 
            return;     // Note: Do not save the RUN or clear TURNS for defender mode
        }

    } else if (INFO.perf_mode === true) {
        mode = "perf";
        start_run = TIMES.start_run;		// start of the signal
    }

    // create a record for analysis later
    //
    var t0 = Date.now();
    var run = {};
    if (tcone !== undefined) {
        run.cone_name = tcone.name;
    }

	//run.start_run = (TIMES.reached_2femur < TIMES.start_run) ? TIMES.start_run0 : TIMES.start_run;		// start of the signal
	run.start_run = start_run;
	run.player_moving = TIMES.player_moving;	// after signal, time to move from zero to something
	run.start_phantom = TIMES.start_phantom;	// start of the phantom signal (redirection after initial target)
	run.phantom_moving = TIMES.phantom_moving;	// 
    run.reached_2femur = TIMES.reached_2femur;	// defender: time from rest to reach 3 femur
    //run.game_reacted = TIMES.game_reacted;
    //run.game_show_target = TIMES.game_show_target;
    run.mock_reacted = TIMES.mock_reacted;
    //run.mock_show_target = TIMES.mock_show_target;

    run.turns = mergeTurns();
	run.end_run = t0;	                        // time the run finished
    run.target_x = INFO.target_x;
    run.target_y = INFO.target_y;
    //run.target_start_dist = INFO.target_start_dist;
	run.ratio_femur_y = INFO.ratio_femur_y;
	run.ref_femur = INFO.ref_femur;
	run.ref_y = INFO.ref_y;
    run.home_x = INFO.home_x;
    run.home_y = INFO.home_y;
    run.number = INFO.rep_run_cnt;
    run.image_width = INFO.image_width;
    run.image_height = INFO.image_height;
    run.image_ratio = INFO.image_ratio;
	run.beat_defender = INFO.beat_defender;     // access gaveup

    //run.time = t0 - TIMES.start_run;        // cached for PerRep stats processing
    if(save_mode  === true) {
        RUNS.push(run);     // result collected in displayRunResults();
        console.log("end.481: ====>  SAVING RUNS=", RUNS, "  HISTORY=", HISTORY.length)
    } else {
        console.log("end.817: INTERRUPT....RUNS ARE NOT SAVED");
    }

    if (INFO.interrupted_mode === true) {
        INFO.state_store_started = false;
    }

    processPerRepStars(run, mode);       // determine stars

    // initialize for next run
    //
    if(tcone !== undefined) {
        tcone.display = null;     // remove border
        tcone.target = null;     // remove border
    }

    INFO.timer_cnt = CONSTS.CONES_RESULT_DISPLAY_DELAY;     // Note: is this used?
    INFO.target_idx = null;               // start again when returned to home posn
    INFO.target_x = 0;               
    INFO.target_y = 0;               
    INFO.cancel_cnt = 0;

    INFO.reps_running = false;
    clearTURNS();
}


// process History session from a user to extract useful info
//
// TODO: fields needs to be []
export const processDrillHistory = (sessions, fields) => {
    var records = [];
    var min_val = [], max_val = [];
    var min_idx = [], max_idx = [];
    var min_cnt = [], max_cnt = [];
    var min_timestamp = [], max_timestamp = [];     //null;
    if ((fields === null) || (fields === undefined) || (sessions === null) || (sessions === undefined) || (sessions.length == 0)) {
        return ([{"field": "---", "value": "---", "timestamp": "NONE" }]);
    }

    for(var i=0; i < sessions.length; i++) {
        var session = sessions[i];
        var out = isolatePerfSummary(session);

        for(var j = 0; j < fields.length; j++) {
            //var j = 0;
            //var field = fields;
            var field = fields[j];
            //console.log("driil.history.1065:              "+i+" out=", out);
            var val = out[field];
            var cnt = out[field+"_cnt"];
            if(val !== undefined) {
                if(min_val[j] === undefined) {
                    min_val[j] = 99999999;
                    max_val[j] = 0;
                }
                if (val > 0) {
                    if (val < min_val[j]) {
                        min_val[j] = val;
                        min_idx[j] = i;
                        min_cnt[j] = cnt;
                        min_timestamp[j] = out["timestamp"];
                    }

                    if (val > max_val[j]) {
                        max_val[j] = val;
                        max_idx[j] = i;
                        max_cnt[j] = cnt;
                        max_timestamp[j] = out["timestamp"];
                        //console.log("driil.history.1083: "+j+"  NEW MAX   out=", out);
                    }
                }
            }
        }
    }
    console.log("driil.history.1087:  min=", min_val, " max=",max_val, " min.cnt=", min_cnt, "  max.cnt=",max_cnt);

    for(var j = 0; j < fields.length; j++) {
        //var j = 0;
        //var field = fields;
        var field = fields[j];

        var record = {};
        record.field = (field === undefined) ? "---" : field;
        //record.value = (min_val[j] === undefined) ? "NONE" : min_val[j].toString() + "  (" + min_cnt[j] + ")";
        record.value = (min_val[j] === undefined) ? "---" : min_val[j];
        record.timestamp = min_timestamp[j];
        records.push(record);
    }
    console.log("driil.history.1107:  MIN  out=", JSON.stringify(records));

    return records;
}



function arraySortAsc(a, b) {
    return a - b;
}

function arraySortDes(a, b) {
    return b - a;
}


// for low sample drills, just return avg
//
export function averageCount(arr, label) {
    var out = [], sum = 0, cnt = 0;
    var alen = arr.length;

    for (var i = 0; i < arr.length; i++) {
        var item = (arr[i]) ? arr[i] : -1;

        out.push(item);
        sum = sum + item;
        cnt = cnt + 1;
    }
    var avg = (cnt === 0) ? 0 : sum / cnt;
    console.log("avg.1225:   ",label,"     AVG=", avg.toFixed(3), "  cnt=", cnt, " sum=",Math.floor(sum));

    return [ avg, cnt ];
}



// sort array and remove outliers, return cleaned up array
//
export function removeOutliers(arr, label, range) {
    var out = [], sum = 0, cnt = 0;
    var alen = arr.length;

    if(alen < 3) {
        console.log("outlier.926: NOT ENOUGH DATA!  ",label, "  cnt=", alen, " ",arr);
        return [ -1, alen ];
    }
    var delta_range = (range) ?  range : CONSTS.PERF_OUTLIER_RANGE;

    arr.sort(arraySortAsc);
    var med = arr[Math.floor(arr.length / 2)];      // find value in array mid-point
    var max_delta = parseFloat(med) * delta_range;
    max_delta = (max_delta === 0) ? 1 : max_delta;
    if (!med) {
        console.log("outlier.1130:    !!!!!!!!!! BAD MEDIAN ",label, "  cnt=", alen, " ",arr);
        return [ -1, alen];
    }

    console.log("outlier.1134: ========>   ",label,"   med=", med.toFixed(3), " arr.len=",arr.length, " max_delta=",max_delta.toFixed(3), " range=",delta_range);
    for (var i = 0; i < arr.length; i++) {
        var item = (arr[i]) ? arr[i] : -1;
        var delta = Math.abs(item - med);
        //console.log("outlier.852:             delta=", delta, "  item=", item, " out=",out);
        if (delta <= max_delta) {
            if(range === undefined) {
                console.log("outlier.1136:      ",i," ++++++++  ACCEPT   item=", item.toFixed(3), "  delta=", delta.toFixed(3), " max_delta=",max_delta.toFixed(3));
            }
            out.push(item);
            sum = sum + item;
            cnt = cnt + 1;
        } else {
            console.log("outlier.1112:      ",i,"           REJECT   item=", item.toFixed(3), "  delta=", delta.toFixed(3), " max_delta=",max_delta.toFixed(3));
        }
    }
    var avg = (cnt === 0) ? 0 : sum / cnt;
    console.log("outlier.857:   ",label,"     AVG=", avg.toFixed(3), "  cnt=", cnt, " sum=",Math.floor(sum));

    return [ avg, cnt ];

}


// rate this rep for 0 to 3 stars
//      - FOR PRACTICE MODE - Repeat loops, extrapolate out to full
//      - if first run, take best record so far as base
//      - otherwise use last personal best record as base
//      - 3 star - anything above best record
//      - 2 star - [ base, base - 2% ]
//      - 1 star - [ base - 2%, base - 4% ]
//      - 0 star - < (base - 4%)
//
//  Note: **** NEED TO SYNC WITH populateSTATSSummary() !!!!!
//
export function processPerRepStars(run0, mode) {
    var rec = INFO.personal_record;
    var field = null, base = null;
    var t00, r00, r01, r04, r05;
    var c01, c02;
    var best_t00 = 999999999, best_r00 = 99999999; 
    var best_r01 = 9999999, best_r04 = 999999, best_r05 = 9999999;
    var best_c01 = 99999, best_c02 = 99999; 
    //console.log("per_turn.1166:     ........PER-REP..... mode=",mode,"  run0=",run0,  "  rec=",rec);

    if ((rec.next_rec !== undefined) && (rec.next_rec !== null) && (rec.value !== null)) {
        field = (rec.field[0]) ? rec.field[0].toUpperCase() : rec.field.toUpperCase();
        base = rec.value;
        if (field === "T00") base = (base / INFO.practice_tot_rep * 1000);       // divide down
        //console.log("per_turn.1729:          ...... ",field," base=", base, "  rec=",rec, "  reps=",INFO.practice_tot_rep);
    } else {
        // if first run, use best rep in this run as base
        //
        //console.log("per_turn.1176:    NO RECORD      ...... RUNS=",RUNS);
        for (var i = 0; i < RUNS.length; i++) {
            var run = RUNS[i];
            t00 = (run.end_run) ? run.end_run - run.start_run : -1;
            r00 = (run.player_moving) ? run.player_moving - run.start_run : -1;
			r01 = (run.phantom_moving) ? run.phantom_moving - run.start_phantom : -1;
            r04 = (run.game_reacted) ? run.game_reacted - run.game_show_target : -1;
            r05 = (run.mock_reacted) ? run.mock_reacted - run.mock_show_target : -1;
			c01 = (run.reached_2femur) ? run.reached_2femur - run.start_run : -1;
			c02 = (run.reached_2femur) ? run.reached_2femur - run.start_run : -1;
            //r04 = run.end_run - run.start_run;
            if ((t00 > 0) && (t00 < best_t00)) best_t00 = t00;
            if ((r00 > 0) && (r00 < best_r00)) best_r00 = r00;
            if ((r01 > 0) && (r01 < best_r01)) best_r01 = r01;
            if ((r04 > 0) && (r04 < best_r04) && (run.hit === true)) best_r04 = r04;
            if ((r05 > 0) && (r05 < best_r05) && (run.hit === true)) best_r05 = r05;
            if ((c01 > 0) && (c01 < best_c01)) best_c01 = c01;
            if ((c02 > 0) && (c02 < best_c02)) best_c02 = c02;
        }
    }

    switch(mode) {
        case "defender":
			var time = (run0.reached_2femur) ? run0.reached_2femur - run0.start_run : -1;
            if (field === null) { base = best_c01; }
            break;

        case "perf":
            // TODO: Need to account for R01 - second turn
            var time = run0.player_moving - run0.start_run;
            if (field === null) { base = best_r00; }
            break;

        case "practice":
            // ref: getPersonalTarget()
            var time = run0.end_run - run0.start_run;
            if (field === null) { base = best_t00; }
            break;

        case "game":
            // compare reaction time
            var time = run0.game_reacted - run0.game_show_target;
            if (field === null) { base = best_r04; }
            break;

        case "mock":
            // compare reaction time
            var time = run0.mock_reacted - run0.mock_show_target;


            // Note: NEED FIX
            if (field === null) { base = best_r05; }


            break;
    }

    var delta = (time / base) - 1;
    var stars = 0;
    if (delta > -0.6) {
        if (time <= base) {
            stars = 3;
        } else if (delta < CONSTS.TWO_STAR_MIN_PCT) {       // 0.02
            stars = 2;
        } else if (delta < CONSTS.ONE_STAR_MIN_PCT) {       // 0.04
            stars = 1;
        }
    }
    INFO.drill_stars = stars;
    console.log("per_rep.1205:          ....STARS SHOW.... =",stars, " delta=",delta.toFixed(4),"  field=",field, " time=",Math.floor(time), " base=",base);

    return stars;
}




// MAIN
// collect results from RUNS and store summary into STATS.
//   - Called from finishRun() used by webcam run types
//   - source signals: stopRun()
//   - this is the brain to figure out how to calculate all the stats
//   - Each module will collect and display what it needs at higher level
//   - This signals updateDrillSummary() up in React layer
//
//  Note1: **** NEED TO SYNC WITH processPerRepStars() !!!!!
//  Note2: **** NEED TO SYNC WITH updateDrillSummary() !!!!!
//
export function populateSTATSSummary() {
    var hidx = HISTORY.length - 1;
    var r00 = [], r01 = [], t01 = [], c01 = [], c02 = [];
	var sum = 0, psum = 0, stime;
	var react, preact, cnt = 0, pcnt = 0;
    var stats = {};

    if ((RUNS.length === 0) || (HISTORY[0] === undefined)) {
        return;     // no data!
    }

	stats.version = CONSTS.AXOS_DATA_VERSION;       // for easy parsing later
    var start_run0 = RUNS[0].start_run;
    var end_run0 = RUNS[RUNS.length - 1].end_run;
	stats.t00 = Math.floor((end_run0 - start_run0)/100)/10;   // total session time across runs of all types
    stats.t00_cnt = INFO.rep_run_cnt;

    // different run mode collect their own stats
    //
	for(var i = 0; i < RUNS.length; i++) {
		var run = RUNS[i];
        switch (INFO.drill_mode) {
            case "perf":
                if(run.player_moving > 0) {         // perf mode
                    react = run.player_moving - run.start_run;   // when we send signal
                    console.log("stats.1410:         PERF  R00 STATS     react=",react,"   player_moving=", run.player_moving, " run.start_run=", run.start_run);
                    r00.push(react);
                    cnt = cnt + 1;
                } else {
                    react = 0;
                }

                if(run.phantom_moving > 0) {        // perf mode
                    preact = run.phantom_moving - run.start_phantom;   // when we send signal
                    console.log("stats.1545:         PERF  R01 STATS     preact=",preact,"   phantom_moving=", run.phantom_moving, " run.start_phantom=", run.start_phantom);
                    r01.push(preact);
                    pcnt = pcnt + 1;
                } else {
                    preact = 0;
                }
                break;

            case "defender":

                // cacluate cog turn power rating here
                //   - calc power_rate for turns in each run
                //   - crate = (max_speed1 / dt1) + (max_speed2 / dt2)
                var turns = run.turns;
                for (var t = 0; t < turns.length - 1; t++) {
                    var turn = turns[t];
                    var turn1 = turns[t + 1];
                    if (turn.type !== "pose") { continue };

                    var hidx = turn.hidx;
                    var down = (turn.c_rate_down > 0) ? turn.c_rate_down : 0;
                    //var up = (turn.c_rate_up > 0) ? turn.c_rate_up : 0;     // got from turn1?
                    var up1 = (turn1.c_rate_up > 0) ? turn1.c_rate_up : 0;
                    var c_rate = down + up1;
                    console.log("stats.1546:    # # # # # # #    C_RATE    turn=",t, " hidx=",hidx, "   tot=",c_rate.toFixed(2), " down=",down.toFixed(2), " up1=",up1.toFixed(2));

                    //if (c_rate > 0) {
                    if ((down > 0) && (up1 > 0)) {
                        c01.push(c_rate);
                        pcnt = pcnt + 1;
                    }
                }
                break;

            case "practice":
                // TODO: go through RUNS to detect abnormalities (short runs)
                //
                break;
        }

        stime = run.end_run - run.start_run;
        t01.push(stime);     // per rep time
		//console.log("stats.151:   REACTION.",i, "   react=",react, " msec", "     preact=",preact, " msec");
	}


    var t0 = Date.now();
    switch (INFO.drill_mode) {
        case "perf":
            if (INFO.drill_tot_rep_cnt < 5) {
                var [ avg, cnt ] = averageCount(r00, "R00");    // KLUDGE: FOR TESTING
                var [ pavg, pcnt ] = averageCount(r01, "R01");
                var [ t1avg, t1cnt ] = averageCount(t01, "T01");
            } else {
                var [ avg, cnt ] = removeOutliers(r00, "R00");
                var [ pavg, pcnt ] = averageCount(r01, "R01");          // always fewer on R01
                var [ t1avg, t1cnt ] = removeOutliers(t01, "T01");
            }

            stats.r00 = Math.floor(avg);        // perf - turn reaction msec
            stats.r00_cnt = cnt;
            stats.r01 = Math.floor(pavg);       // perf - mid-turn reaction msec
            stats.r01_cnt = pcnt;
            stats.t01 = Math.floor(t1avg);      // average session time per run
            stats.t01_cnt = t1cnt;
            stats.tt0 = HISTORY[hidx].timestamp - HISTORY[0].timestamp;      // total elapse time (not for game mode), use for score calc
            stats.tt0_cnt = hidx;      // number for history frames for score calculator

            INFO.notify_messages = [];
            INFO.notify_messages.push("R00: " +  stats.r00 + "  msec" + "  (" + stats.r00_cnt + ")");   // also show on video
            INFO.notify_messages.push("R01: " +  stats.r01 + "  msec" + "  (" + stats.r01_cnt + ")");
            break;

        case "defender":
            var [ avg, cnt ] = removeOutliers(c01, "C01");
            var [ pavg, pcnt ] = averageCount(c02, "C02");

            stats.c01 = Math.floor(avg * 100) / 100;        // perf - turn reaction msec
            stats.c01_cnt = cnt;
            stats.c02 = pavg;       // perf - mid-turn reaction msec
            stats.c02_cnt = pcnt;

            INFO.notify_messages = [];
            INFO.notify_messages.push("C01: " +  stats.c01.toFixed(2) + "  " + "  (" + stats.c01_cnt + ")");
            //INFO.notify_messages.push("C02: " +  stats.c02 + "  " + "  (" + stats.c02_cnt + ")");   // also show on video
            break;

        case "practice":

            // process heads up stats
            //
            stats.h00 = Math.floor((INFO.heads_up_frames) / INFO.valid_frames * 100);   // total heads up %
            stats.h00_cnt = INFO.rep_run_cnt;
            console.log("popSTATS.1211: ................... H00 ===>  ", stats.h00, "  heads_up_frames=", INFO.heads_up_frames, "  valid_frames=",INFO.valid_frames);

            INFO.notify_messages = [];
            INFO.notify_messages.push("T00: " +  stats.t00 + "  sec" + "  (" + stats.t00_cnt + ")");
            INFO.notify_messages.push("H00: " +  stats.h00 + "  %");
            break;
    }


    /*
    if (INFO.defender_mode === true) {
    } else if (INFO.perf_mode === true) {
    } else if (INFO.practice_mode === true) { } */

    stats.email = INFO.email;
    stats.uid = INFO.uid;
    stats.drill_hash = INFO.drill_hash;
    stats.set = INFO.drill_set_cnt;
    INFO.bot_stats = Object.assign({}, stats);  // copy object, save it for bot remote control
    insertSTATSSummary(stats);      // add it back in for storage

	INFO.timer_display = avg;
	INFO.ptimer_display = (pcnt > 0) ? pavg : 0;
    TIMES.timer_stop_display = t0 + CONSTS.CONES_RESULT_DISPLAY_MSDELAY;
    INFO.show_results = true;
    console.log("popSTATS.1008:  STATS SUMMARY POPULATED  ", INFO.notify_messages[0], " defend=",INFO.defender_mode," perf=",INFO.perf_mode, " drill=",INFO.practice_mode, " now=",Date.now()%100000/1000);
    //timerDisplayResult("Populate.Stats");

    window.dispatchEvent(INFO.summary_event);       // data ready, can be displayed
}


// copy valid stats fields into STATS
//
export function insertSTATSSummary(stats) {
    for(var i = 0; i < CONSTS.PERF_KEYS.length; i++) {
        var key = CONSTS.PERF_KEYS[i];
        var cnt = CONSTS.PERF_KEYS[i]+"_cnt";
        if ((stats[key] > 0) || (stats[cnt] > 0)) {
            console.log("insertSTATSSummary.1538:          ",key, "=", STATS[key], "    ",cnt,"=",STATS[cnt]);
            STATS[key] = stats[key];
            STATS[cnt] = stats[cnt];
        }
    }
}


// return snapshot the STATS perf summary
//
export function extractSTATSSummary() {
    var run = {};
    for(var i = 0; i < CONSTS.PERF_KEYS.length; i++) {
        var key = CONSTS.PERF_KEYS[i];
        var cnt = CONSTS.PERF_KEYS[i]+"_cnt";
        if ((STATS[key] > 0) || (STATS[cnt] > 0)) {
            run[key] = STATS[key];
            run[cnt] = STATS[cnt];
        }
    }

    //console.log("extractSTATSSummary.1242:  Return=", run);
    return run;
}


// return only perf summary from object
//
export function isolatePerfSummary(run) {
    var out = {}
    for(var i = 0; i < CONSTS.PERF_KEYS.length; i++) {
        var key = CONSTS.PERF_KEYS[i];
        var cnt = CONSTS.PERF_KEYS[i]+"_cnt";
        if ((run[key] > 0) || (run[cnt] > 0)) {
            //console.log("iso_summary.1740:          ",key, "=", run[key], "    ",cnt,"=",run[cnt]);
            out[key] = run[key];
            out[cnt] = run[cnt];
        }
        out["timestamp"] = run["timestamp"];
    }

    //console.log("iso_summary.1051:  Return=", out, " run=",run.length);
    return out;
}


// merge STATS perf summary into object
//
export function mergeSTATSSummary(run0) {
    var run = {...run0};
    for(var i = 0; i < CONSTS.PERF_KEYS.length; i++) {
        var key = CONSTS.PERF_KEYS[i];
        var cnt = CONSTS.PERF_KEYS[i]+"_cnt";
        if ((STATS[key] > 0) || (STATS[cnt] > 0)) {
            console.log("mergeSTATSSummary.1033:          ",key, "=", STATS[key], "    ",cnt,"=",STATS[cnt]);
            run[key] = STATS[key];
            run[cnt] = STATS[cnt];
        }
    }

    //console.log("mergeSTATSSummary.847:  Return=", run, " STATS=",STATS);
    return run;
}

// initialize perf summary fields
export function clearSTATSSummary() {
        // clear up perf summary
        for(var i = 0; i < CONSTS.PERF_KEYS.length; i++) {
            var key = CONSTS.PERF_KEYS[i];
            var cnt = CONSTS.PERF_KEYS[i]+"_cnt";
            STATS[key] = 0;
            STATS[cnt] = 0;
        }
}

// reset all temporary state 
//
export function resetSession() {

        INFO.has_calibration = false;    // NO! 
        resetCalibration();     // in practice mode, we should calib event to start timer
        INFO.interrupted_mode = false;    //setState("interrupted", false);   NOT THIS!  SMOKING GUN!
        INFO.perf_running = false;
        INFO.target_idx = null;
        INFO.home_id = null;
        TIMES.timer_stop_display = 0;
        TIMES.timer_restart_cooldown = 0;   // ready to start
        INFO.last_video_time = null;   

        INFO.state_store_started = false;
        INFO.state_store_completed = false;

        INFO.show_defender = false;
        INFO.defend_gave_up = false;
        INFO.defend_restart_time = null;
        //INFO.countdown_time = null;       // BAD

        var t0 = Date.now();
        TIMES.start_run = t0;   // ready to start

        // clear per session stats
        INFO.drill_stars = 0;
        INFO.heads_up_frames = 0;   // ready to start
        INFO.valid_frames = 0;   // ready to start
        INFO.calibrate_cnt = 0;
        INFO.cone_dy = 0;
        INFO.cone_y = 0;
        INFO.home_x = 0;
        INFO.home_y = 0;

        STATS.pose_sess_turn_cnt = 0;

        clearSTATSSummary();
        lockCones(false);   // unlock everything so it can be changed again


        initHistory();
        clearTURNS();
        clearRUNS();        // do it once pser game session
		console.log("reset.1063:  ####################  SESSION RESET  stop_display=",TIMES.timer_stop_display, "  CONES=",CONES);
}



// femur calibrated and player reached center
// init session stopped, a session can have many runs
//
export function startSession() {
        TIMES.session_start = Date.now();
        TIMES.session_stop = null;
        INFO.target_idx = null;
        INFO.cone_target_x = 0;
        INFO.cone_target_y = 0;
        INFO.rep_run_cnt = 0;      // start over
        INFO.show_results = false;

        //INFO.cancel_cnt = CONSTS.HOME_COOLDOWN_THRESHOLD;  // prevents toggle to restart immediately

        resetSession();
        console.log("startSession.1306:  SESSION START COMPLETE  now=",Date.now()%100000/1000);
}


// session stopped, show the results of all the runs
//     - Finished all the Sets in this Session
//
export function stopSession(from) {
        INFO.cancel_cnt = CONSTS.HOME_COOLDOWN_THRESHOLD;  // prevents toggle to restart immediately
        INFO.perf_running = false;
        INFO.rep_run_cnt = INFO.rep_run_cnt - 1;  // correction

        lockCones(false);   // unlock everything so it can be changed again
        resetCalibration();     // in practice mode, we should calib event to start timer
        //INFO.has_calibration = false;       // re-calib for new session...should we really disable? no?

        TIMES.session_stop = Date.now();
        TIMES.timer_restart_cooldown = Date.now() + CONSTS.SESSION_RESTART_MSDELAY;
        //setFrameEvent("STOP");
        //populateSTATSSummary();     // calculate STATS perf summary
        //timerDisplayResult("Stop.Session");
        //playAudio(CONSTS.SESSION_END_PATH, "stop_session.1693");      // doing it in processDrillReps()

        INFO.knn_last_gesture = null;
        INFO.target_idx = null;
        INFO.drill_tot_set_cnt = null; 
        INFO.drill_set_cnt = 0; 
        INFO.rep_run_cnt = 0;      // start over
        INFO.no_cone_cnt = CONSTS.CONES_MAX_NO_CONE_FRAME+1;
        console.log("stopSession.1031:  SESSION STOP COMPLETE  from=",from, " start=",TIMES.start_timer_run/1000, " now=", Date.now()%100000/1000);

}


// Finished the Runs in this Set
//     - When all the Sets are done go to StopSession()
//
export function finishRun(session_finished) {
    if (INFO.defender_mode === false) {
        stopRun(true, "finish.run.1708");
    } else {
        stopRun(session_finished, "finish.defned.run.1836");
    }

    console.log("home.1541: ------- RUN COMPLETED @CORE -------- run_cnt=", INFO.rep_run_cnt, " session_finished=", session_finished, " tot_rep=",INFO.drill_tot_rep_cnt, " now=",Date.now()%100000/1000);
    if(session_finished  === true) {
        var t0 = Date.now();
        console.log("home.529:  ******* MAX RUN REACHED @CORE ******** ", t0/1000);
        INFO.interrupted_mode = false;
        TIMES.timer_restart_cooldown = t0 + CONSTS.SESSION_RESTART_MSDELAY;
        TIMES.timer_stop_display = t0 + CONSTS.CONES_RESULT_DISPLAY_MSDELAY;
        playAudio(CONSTS.SESSION_END_PATH, "goals_all_complete.1596");     // hard chime for finish one loop
        //INFO.notify_message1 = "SESSION COMPLETED"
        //INFO.notify_message2 = "";

        setFrameEvent("STOP");
        INFO.notify_color = "red";
        INFO.auto_completed = true;
        populateSTATSSummary();     // calculate STATS perf summary

        setTimeout(()=> {
            console.log("home.70:  ******* SESSION COMPLETED @DELAY ******** now=", Date.now()%100000/1000)
            stopSession("finishRun.1562");
            initWebcamAI(guiState.net, false, "finish_perf.1587");    // wait for awhile to catch last bit of player
            window.dispatchEvent(INFO.session_close_event);      // tell UI to clean up
        }, 6000)
        //INFO.setState('session_stopped', true);       // this has context isssue, use event signal instead!
        return;
    }
}




// manage practice and challenge detection and analysis
//
export function processPerformance() {
    var react_time = 0, complete_time = 0;
    //console.log("perf.807: ********* PROCESS PERF  perf=",INFO.perf_mode, "  hidx=", HISTORY.length);

    var t0 = Date.now();
    if ((INFO.defender_mode === true) && (INFO.defender_running === true)) {
        // defender mode: check if defender gave up
        //     - extract acceleration duration and rate (after each detected turn)
        //
        if (INFO.drill_tot_rep_cnt === 0) {
            console.log("def_proc.1701:      REP_CNT ZERO, STOP NOW ", INFO.practice_run_mode);
            finishRun(true);
        }
    }

    else if (INFO.perf_mode === true) {

        // manage start-stop of run-to-target cone drill
        //    - if not target, start a new session if calibration is done and at home
        //
        //console.log("perf.766:     . . . targ_idx=", INFO.target_idx, " calib=",INFO.has_calibration, " at_home=",at_home);
        if (INFO.target_idx === null)  {
            if (INFO.has_calibration  === true) {       // no calibration, no goal is possible
                if (INFO.perf_delay_mode === false) {

                    var at_home = checkHomeZone();       // see if user reached home, it starts flow
                    if ((at_home  === true) && (t0 > TIMES.timer_restart_cooldown)) {
                        // brief delay before starting next run
                        //
                        INFO.perf_delay_mode = true;      // use this to block another run while on timer
                        var delay = (Math.random() * 1000) + 1000;
                        setTimeout(()=> {
                            var start_time = startRun();
                            INFO.perf_delay_mode = false;      // use this to block another run while on timer
                            console.log("home.45:  ******* STARTING PERF RUN ********  delay=",delay,"  start=", Math.floor(start_time), " ", INFO.rep_run_cnt, " tot_rep=", INFO.drill_tot_rep_cnt, " now=",Date.now()%100000/1000);
                            playAudio(CONSTS.MINOR_PROGRESS_PATH, "reached_home.1784");

                            if(INFO.record_mode === true) {
                                //recordOutput(INFO.output_canvas, TIMES.start_run, true);   // start recording when session starts
                                recordOutput(INFO.output_canvas, INFO.file_name, true);   // start recording when session starts
                            }
                        }, delay);
                    }
                }
            }
        } else {
            var complete_time = checkGoal(CONES[INFO.target_idx]);   // working on a target, wait until we get it
            if(complete_time > 0) {
			    console.log("perf_proc.1274: ----->  CHECK GOAL SUCCESS! ", complete_time, " run_cnt=",INFO.rep_run_cnt, " tot_rep=", INFO.drill_tot_rep_cnt);
                var finished = (INFO.rep_run_cnt >= (INFO.drill_tot_rep_cnt - 1)) ? true : false;
                finishRun(finished);
            }
        }
    }

    // check if the session is done, got enough reps
    //
    else if ((INFO.practice_mode === true) && (INFO.reps_running === true)) {
        if (INFO.practice_run_mode === "reps") {
            if (INFO.drill_tot_rep_cnt === 0) {
                console.log("perf_proc.1641:      REP_CNT ZERO, STOP NOW ", INFO.practice_run_mode);
                finishRun(true);
            }
        } else {
            if (TIMES.start_timer_run  && (TIMES.start_timer_run > 0)) {
                var time = Date.now();
                var max = TIMES.start_timer_run + (INFO.timer_run_duration * 1000);
                if (time > max) {
                    console.log("perf_proc.1619:      EXCEEDED TIMER DURATION, STOP NOW   mode=",INFO.practice_run_mode, " time=", time, " max=", max, " start_timer_run=", TIMES.start_timer_run);
                    finishRun(true);
                }
            }
        }
    }


}


// see if player has reached home
export function checkHomeZone() {
    var reached = false;
    var idx = getConeByID(INFO.home_id, CONES);
    var cone = CONES[idx];      // in case array changes

    var time = checkGoal(cone);
    if(time > 0) {
        console.log("time.95: ********* PLAYER IS AT HOME ******  ", INFO.cancel_cnt, " time =",time);
        //setFrameEvent("HOME");        // not giving much value
        reached = true;
        if (!INFO.femur_home_px) {
            INFO.femur_home_px = INFO.femur_px;     // lock it in for this session for consistency
            addPhantomCones();            // calc phantom cones now that we are at home
        }
    }

    return reached;
}



// send turn signal, play sound
export function signalPlayer(cone_idx) {
    var hidx = HISTORY.length - 1;
	var f0 = HISTORY[hidx];
	var pose = f0.pose;

    if (pose.valid === false) {
        console.log("sig.1315:   POSE NOT VALID, NO PLAYER SIGNAL  hidx=",hidx, " cone_idx=",cone_idx, "  cone=",CONES);
        return null;
    }

    //console.log("sig.158:   cone_idx =", cone_idx);
    if(cone_idx >= 0) {
        var cone = CONES[cone_idx];
        var id = cone.id;
        INFO.target_idx = cone_idx;
        INFO.cone_target_x = cone.ctr_x;
        INFO.cone_target_y = cone.ctr_y;
        INFO.target_x = cone.ctr_x;
        INFO.target_y = cone.ctr_y;
        //INFO.target_start_dist = calcDistance(null, pose.ctr_x, cone.ctr_x, pose.ctr_y, (cone.ctr_y - cone.dy));
        cone.target_start_dist = calcDistance(null, pose.ctr_x, cone.ctr_x, pose.ctr_y, (cone.ctr_y - cone.dy));
        cone.display = "target";

        //showTargetDiv(cone.ctr_x, cone.ctr_y);      // display in real time overlay FIRST
        window.dispatchEvent(INFO.show_target_cone_event);       // tell UI to show the cone IMMEDIATELY (no AI delay)
        //console.log("start.607: ########## START=",cone.name, " hidx=",hidx," c.id=",cone.id," dist=",cone.target_start_dist, " px=",pose.ctr_x,  "py=",pose.ctr_y, " c.dy=",cone.dy, "  cx=",cone.ctr_x, " cy=",cone.ctr_y);

        //playAudio(CONSTS.XXXX);     // hard chime
        Reach_Cnt[id] = 0;
        Start_Time[id] = Date.now();
        console.log("sig.157:   ------>  NEW TARGET CONE SELECTED  hidx=",hidx, " idx=",cone_idx, " c.id=", cone.id, " start_time=",Start_Time[id], "  cone=",CONES, " travel_dist=",cone.target_start_dist);

        return(Start_Time[id]);
    }
}




// this is if we are playing a recorded video (not live webcam), we look at the frame pixels
// and see if this is "review mode" where we can extract the "start signal" from a past event
// and determine what is going on
function checkStartSignal(context) {
    var width = context.width;
    var height = context.height;
    var frame = context.getImageData(0, 0, width, height);	// grab pixels for analysis
	var d = frame.data;		// prepare and pass in tuple-4 array
	var data = [];


}


// return if reached cone
//    - for reacted - check traveled distance from start of sig (not relative to cone)
//    - for reverse - check when start to get closer
//
function calcGoalDist(stats, cone, pose) {
    var width = INFO.image_width;
    var height = INFO.image_height;
    var hidx = HISTORY.length - 1;
    var dx, dy, dx_thresh, reacted = false, reached = false;
    var id = cone.id;

    var dx = Math.floor(Math.abs(pose.ctr_x - cone.ctr_x));
    var dy = Math.floor(Math.abs((cone.ctr_y - cone.dy) - pose.ctr_y));   // not abs value, less is OK

    var goal_dx = dx;
    var goal_dy = dy;
    var goal_dist = calcDistance(stats, pose.ctr_x, cone.ctr_x, pose.ctr_y, (cone.ctr_y - cone.dy));
    //console.log("goal.729:   DIST  CONE=",cone.name, " hidx=",hidx, "   dist=",goal_dist, " c.dy=",cone.dy, "  cx=",cone.ctr_x, " cy=",cone.ctr_y, 
                //"  px=", pose.ctr_x, " py=",pose.ctr_y, " femur_y=", Math.floor(stats.ratio_femur_y), " ref_y=", stats.ref_y);

    // if traveled dist is past 1 femur, then consider racted
    //
    var traveled = cone.target_start_dist - goal_dist;          // Note: start_dist is pose->goal at start
    if (cone.phantom === false) {
        if((cone.home === false) && (traveled > (INFO.femur_home_px))) {
            reacted = true;
            //console.log("goal.2088:            # # # # #   PERF ",((cone.phantom) ? "_PHANTOM_" : ""), " REACTED  @   hidx=",hidx, " cone=",cone.name,"  reacted=",reacted, "  femur=",INFO.femur_home_px, " traveled=", traveled, " start_dist=",cone.target_start_dist, " goal_dist=",goal_dist);
        }
    } else {
        // reacted when start to get closer to new cone

    }

    //console.log("dist.936:  GOAL.",cone.id,":  goal_dist=",goal_dist, "  max_dist=", CONSTS.GOAL_MAX_DIST_MATCH, " scale_dist=", INFO.scale_dist);
    if(goal_dist < (CONSTS.GOAL_MAX_DIST_MATCH * INFO.scale_dist)) {    // loosely check
        reached = true;
        if(Reach_Cnt[id] === undefined){
            Reach_Cnt[id] = 1;
        } else {
            Reach_Cnt[id] = Reach_Cnt[id] + 1;
        }
        //console.log("goal.628: ***** REACHED CONE=",cone.name, "  cnt=",Reach_Cnt[id], "  cx=",cone.ctr_x, " cy=",cone.ctr_y, "  px=", pose.ctr_x, " py=",pose.ctr_y);
    }

    return [ reached, reacted, traveled, goal_dx, goal_dy, goal_dist ];
}



// MOVE TO UTIL
// UTIL:  DEGREE ZONE FOR REVERSAL DETECTION
//     - OLD: divide 360 dgr into 4 zones:  0 = 316 to 45, 1 = 46 to 135, 2 = 136 to 225, 3 = 226 to 315
//     - divide 360 dgr into 4 zones:  0 = 340 to 20, 1 = 21 to 160, 2 = 161 to 200, 3 = 201 to 340
//     - reversal is in moving towards opposite zones (e.g. 3 vs 1)
//
function degreeZone(degree) {
    //var zone = Math.floor((degree + 45) / 90) % 4;
    var zone;
    var tick = Math.floor(degree / 20);
    if ((tick === 17) || (tick === 0)) {
        zone = 0;
    } else if ((tick === 8) || (tick === 9)) {
        zone = 2;
    } else if ((tick > 0) && (tick < 8)) {
        zone = 1;
    } else {
        zone = 3;
    }

    var opp_zone = (zone + 2) % 4;

    return [ zone, opp_zone ]
}




// look at PTURN and determine if we have completed a practice loop
//    - initialy just look at the pose side-to-side vector (turn.degree, distance, time)
//    - later, deep dive into ball and pose relationship to determine accuracy
//    - later, determine pose-ball distance to assess level of control
export function calcPracticeRep() {
    var hidx = HISTORY.length - 1;
    var ptidx = PTURNS.length - 1;
    var turn0 = PTURNS[ptidx];        //.slice(-1)[0];
    var turn1 = null;

    // START TIMER ONCE WE FIND THE "STARTING TURN"
    //
    if ((INFO.practice_mode === false)  || (INFO.reps_running === false)) {
        return 0;
    }

    // Locate Initial ANCHOR
    //
    if(INFO.practice_turn_idx1 == null) {
        // first time through, need to find the first turn after start,  KLUDGE: ASSUMES 270 or 90!!!
        var time = turn0.timestamp - TIMES.player_moving;   // filter out starting gitters
        var dist = calcDistance(null, turn0.x, INFO.practice_start_x, turn0.y, INFO.practice_start_y);      // from the home position
        var [ zone, opp ] = degreeZone(turn0.degree);       // use more robust zone detection

        //if ( ((Math.abs(turn0.degree - 270) < CONSTS.TURN_ANCHOR_DEGREE_DELTA) || 
        //       (Math.abs(turn0.degree - 90) < CONSTS.TURN_ANCHOR_DEGREE_DELTA)) &&
        // (dist > (INFO.custom_min_loop_px  * INFO.scale_dist))  &&
        if (((zone === 1) || (zone === 3)) && (dist > CONSTS.TURN_MIN_LOOP_TRAVEL )  && (time > CONSTS.TURN_MIN_ANCHOR_TIME)) {

            console.log("calc_rep.1352:         FOUND ANCHOR   hidx=",hidx, "  PTURN @ptidx=", ptidx, " dgr.zone=",zone," angle=", (turn0.degree - 90), "(<",CONSTS.TURN_ANCHOR_DEGREE_DELTA, ") ",
                         " dist=",dist,"(>", INFO.custom_min_loop_px , ")  time=",time," (>", INFO.custom_min_loop_msec, ") ==> deg=", turn0.degree, " x=",turn0.x, " y=",turn0.y, " time=",time);
            INFO.practice_turn_idx1 = ptidx;

            // starting performance timing once we have set an anchor
            //
            var t0 = Date.now();
            TIMES.start_run = t0;	    // below not use, artifically set them to avoid calc probs later
            TIMES.start_timer_run = t0;	    // for practice count down timer only
            TIMES.start_full_turn = t0;	    // below not use, artifically set them to avoid calc probs later
            INFO.heads_up_frames = 0;        // start tracking heads up %
            INFO.valid_frames = 0;          // in sync with heads_up_frames
            setFrameEvent("TIMING-START");

            INFO.notify_title = "TIMING START!";
            INFO.notify_size = 40;
            TIMES.timer_stop_display = Date.now() + 2500;
            playAudio(CONSTS.MINOR_PROGRESS_PATH, "prac_start.1964");     // first turn detected, start timing

        } else {
            //console.log("calc_rep.1355:               REJECTED ANCHOR  @ idx=", idx, "hidx=", hidx, " deg=", turn0.degree, " x=",turn0.x, " y=",turn0.y, " time=",time);
            //PTURNS[ptidx].reject = true;  // no need for anchor
            console.log("calc_rep.1355:              ------ REJECTED ANCHOR: @ptidx=", ptidx,"  hidx=", hidx,
                         " dist=",dist,"(>", INFO.custom_min_loop_px , ")  time=",time," (>", INFO.custom_min_loop_msec, ") ",
                        "==> deg=", turn0.degree, " x=", turn0.x, " y=", turn0.y, " scale=",INFO.scale_dist);
        }
        return 0;
    }


    // DEBUG: DISPLAY INTERIM TURN MARKERS
    // - here always have idx1
    // - if idx2 is set then we are completing the loop
    turn1 = PTURNS[INFO.practice_turn_idx1];
    displayBlock("red", turn1.x, turn1.y + INFO.cone_dy, 10, 10);   // DEBUG MARKER
    if(INFO.practice_turn_idx2 !== null) {
        // first half cycle complete, do second half
        //console.log("calc_rep.1366: ", PTURNS.length, "           START SECOND HALF ------ 1st_idx=",INFO.practice_turn_idx1,"  2nd_idx=",INFO.practice_turn_idx2, " x=",turn0.x, " y=",turn0.y);
        turn1 = PTURNS[INFO.practice_turn_idx2];
        displayBlock("pink", turn1.x, turn1.y + INFO.cone_dy, 10, 10);  // DEBUG MARKER
    } 

    INFO.practice_degree_log.push(turn0.degree);

    var dist = calcDistance(null, turn0.x, turn1.x, turn0.y, turn1.y);
    var time = turn0.timestamp - turn1.timestamp;
    //console.log("calc_rep.1361: ", PTURNS.length, "              ------ t1d=",turn1.degree, " t0d=",turn0.degree, " del.d=",delta, " x=", turn0.x, " y=",turn0.y, "  dist=",dist,"  last_idx=",INFO.practice_turn_idx1);

    // Calculate POSE REVERSAL
    //     - divide 360 dgr into 4 zones:  0 = 316 to 45, 1 = 46 to 135, 2 = 136 to 225, 3 = 226 to 315
    //     - reversal is in moving towards opposite zones (e.g. 3 vs 1)


    //     - IF going in opp diredction and dist is long, then switch anchor? (????)




    //
    var [ zone0, opp0 ] = degreeZone(turn0.degree);     // first leg
    var [ zone1, opp1 ] = degreeZone(turn1.degree);     // second leg
    var good_turn = false;
    //if ((zone0 == opp1) && (dist > (INFO.custom_min_loop_px  * INFO.scale_dist))  && (time > INFO.custom_min_loop_msec)) {
    if ((zone0 == opp1) && (dist > INFO.custom_min_loop_px )  && (time > INFO.custom_min_loop_msec)) {
        good_turn = true;
    } else {
        if ((zone0 == zone1) && (dist > (INFO.custom_min_loop_px * 2) )  && (time > (INFO.custom_min_loop_msec * 2))) {
            good_turn = true;       // KLUDGE: in case of bad anchor dectect, recovery
        }
    }


    if (good_turn === true) {

        if(INFO.practice_turn_idx2 !== null) {
            console.log("calc_rep.1345.xxx: ", PTURNS.length, " ====== DETECTED FULL TURN @ptidx=", ptidx,"  hidx=", hidx,  " zone0=",zone0, "(",opp1,")",
                    " dist=",dist,"(>", INFO.custom_min_loop_px , ") time=",time,"(>", INFO.custom_min_loop_msec,") ",
                    "==> t1d=",turn1.degree, " *t0d=",turn0.degree, " z1=",zone1, " z0=",zone0, " x=", turn0.x, " y=",turn0.y);
            setFrameEvent("LOOP-"+INFO.drill_tot_rep_cnt);
            playAudio(CONSTS.REP_SUCCESSS_PATH, "prac_loop.2009");     // finished a loop, need to do it here

            var run = {};
            run.start_run = TIMES.start_full_turn;		// start of the half turn
            run.end_run = turn0.timestamp;		// start of the half turn
            run.dist = dist;		// start of the signal
            RUNS.push(run);     // result collected in displayRunResults();
            processPerRepStars(run, "practice");    // sets drill_stars
            TIMES.start_full_turn = turn0.timestamp;	// set it for the next turn

            INFO.practice_turn_idx1 = ptidx;
            INFO.practice_turn_idx2 = null;
            //INFO.rep_run_cnt = INFO.rep_run_cnt + 1;      // do it at top level
            return 1;        // detected a turn
        } else {
            console.log("calc_rep.1798.xxx: ", PTURNS.length, "      +++++++ HALF A TURN ++++++  @ptidx=",ptidx, "  hidx=",hidx, " zone0=",zone0, "(",opp1,")",
                    " dist=",dist,"(>", INFO.custom_min_loop_px , ") time=",time,"(>", INFO.custom_min_loop_msec,") ",
                    " ==>  t1d=",turn1.degree, " *t0d=",turn0.degree, " z1=",zone1, " z0=",zone0, " x=", turn0.x, " y=",turn0.y);
            INFO.practice_turn_idx2 = ptidx;      // got half a cycle
        }
        PTURNS[ptidx].reject = false;
    } else {
        // if in same direction as anchor, extend anchor?
        //
        PTURNS[ptidx].reject = true;
        console.log("calc_rep.1387.xxx:      - - - - - REJECTED:  @ptidx=",ptidx," hidx=", hidx, " zone0=",zone0, " (",opp1,")",
                    " dist=",dist,"(>", INFO.custom_min_loop_px , ") ", " time=",time,"(>", INFO.custom_min_loop_msec,") ",
                    "==>  t1d=",turn1.degree, " *t0d=",turn0.degree, " z1=",zone1, " z0=",zone0, " x=", turn0.x, " y=",turn0.y);
    }
    return 0;   // no turn
}


// revisit the goal and check if we did not detect a goal becuase of femur error
//    - After a turn, look back to see if we have reached a goal
//    - Starting from the goal, step back 10 frams to see if we reached the goal b4 the turn
//    - This may be an artifact of detection lag (smoothing..etc)
//    - need to reset after every turn
export function recheckGoal() {
    var hidx = HISTORY.length - 1;
    var end_hidx = hidx - CONSTS.GOAL_REVIEW_HIDX;
    var id = INFO.target_idx;   // current target cone
    var cone = CONES[id];
    var cone_id = (cone === undefined) ? "none" : cone.id;

    var home_cone = (cone === undefined) ? true : cone.home;
    if(home_cone  === true) {
        return 0;       // skip home, only re-check for real goal
    }

    // find previous local minimum
    var last_min_dist = 9999999;
    var last_dist = 9999999;
    var reached_cnt = 0;
    for(var i = hidx; i >= end_hidx; i--) {
        var f1 = HISTORY[i];
        var dist = f1.action.goal_dist;

        //if ((dist < last_dist) && (dist < last_min_dist)) 
        //if (dist < CONSTS.GOAL_REVIEW_DIST_MATCH) 
        if (dist < (CONSTS.GOAL_REVIEW_DIST_MATCH * INFO.scale_dist)) {
            reached_cnt = reached_cnt + 1;
            //last_min_dist = dist;
            hidx = i;
            console.log("review.1529:     POSSIBLE DIST AT GOAL    hidx=",i,":  dist=",dist, "  cone_id=",cone_id, "  cone.idx=",id, "  reached_cnt=",reached_cnt);
        }
        last_dist = dist;
    }

    // need to have multiple reached observation to confirm
    //
    var delta = Date.now() - TIMES.session_start;  // Do not recheck if just started new session
    if ((reached_cnt > CONSTS.GOAL_REVIEW_CNT_THRESHOLD) && (delta > CONSTS.GOAL_REVIEW_TIME_THRESHOLD)) {
        End_Time[id] = Date.now();
        //if (home_cone === false) { 
            console.log("review.1727:          +++++ REVIEW - GOAL REACHED +++++ ",cone.id, " hidx=",hidx, " ", Math.floor(End_Time[id]), " ", cone);
            playAudio(CONSTS.REP_SUCCESSS_PATH, "perf_goal2.2083");     // two tone success chime signals end
            setFrameEvent("V1GOAL"+INFO.rep_run_cnt+"-"+cone.name);
            INFO.phantom_running = false;    // ends when we reach goal
            INFO.target_idx = null;
            INFO.cone_target_x = 0;
            INFO.cone_target_y = 0;
            INFO.target_x = 0;
            INFO.target_y = 0;
            cone.display = null;
            cone.target = null;
            window.dispatchEvent(INFO.show_target_cone_event);       // tell UI to hide the <div> cone

            if(Start_Time[id] === undefined) {
                console.log("review.1750:       BAD  Start_Time=",Start_Time, "  id=",id, "   End_Time[id]=",End_Time[id]);
                return 666;   // for non-timed events like reaching home
            } else {
                console.log("goal.2096:               RE-CHECK GOAL TIME   id=", id, "  end=",End_Time[id], " start=", Start_Time[id]);
                return End_Time[id] - Start_Time[id];
            }
        //}
    }

    return 0;

}




var Reach_Cnt = [];
var Start_Time = [];
var End_Time = [];

// determin if goal has been reached, if got to a phantom node check if need to sudden reverse
export function checkGoal(cone) {
    var reached, reacted, traveled, ptraveled, react_time, goal_dx, goal_dy, goal_dist;
    var preached, preacted, pcone_idx, pid, pcone;
    var hidx = HISTORY.length - 1;
	var f0 = HISTORY[hidx];
    if((cone === undefined) || (f0 === undefined) || (f0.pose === undefined) || (f0.pose.valid === false)) {
        //console.log("goal.225:   NO cone or pose");
        return 0;     // need valid data first
    }

	var pose = f0.pose;
	var action = f0.action;
	var ball = f0.ball;
	var stats = f0.stats;
    var id = cone.id;

    if(INFO.review_running  === true) {
        checkStartSignal();
    }

    [ reached, reacted, traveled, goal_dx, goal_dy, goal_dist ] = calcGoalDist(stats, cone, pose);
    action.goal_dx = goal_dx;
    action.goal_dy = goal_dy;
    action.goal_dist = goal_dist;
    //console.log("goal.2422:                   . . . CHK GOAL   hidx=",hidx, " cone=",cone.name, " reacted=",reacted, 
    //            " plus=",INFO.last_traveled_plus, " minus=",INFO.last_traveled_minus, " last_delta=", INFO.last_traveled_delta," last_travel=",INFO.last_traveled,
    //            " phantom=",INFO.phantom_running, " start_dist=",cone.target_start_dist, " goal_dist=",Math.floor(goal_dist), " traveled=",Math.floor(traveled));
    //if ((reacted  === true) && (INFO.target_reacted === false)) {
    if(INFO.phantom_running === false) {

        //if(INFO.phantom_running === false) {
        if ((reacted  === true) && (INFO.target_reacted === false)) {
            INFO.target_reacted = true;     // semaphore to avoid repeat
            var dratio = traveled / INFO.femur_home_px;  // linear prorate back to femur dist for higher precision

            TIMES.player_moving = Date.now();
            setFrameEvent("REACT"+INFO.rep_run_cnt+"-"+cone.name);
            if(TIMES.player_moving > 0) {
                var lapse_time = (TIMES.player_moving - TIMES.start_run) / dratio;  // prorate back
                react_time = Math.floor(lapse_time);
                console.log("goal.736:  + + + + + + +  DISPLAY REACTION TIME   hidx=",hidx, " x=",pose.ctr_x, " y=",pose.bottom,"  @ react=", react_time.toFixed(3), " dratio=",dratio.toFixed(2)," phantom=", INFO.phantom_running, " to_goal=", Math.floor(action.goal_dist), "  start_dist=",cone.target_start_dist, "  traveled=",traveled, " femur=",INFO.femur_home_px);
            } else {
                react_time = 0;     // didn't happen yet
            }
            REACT_STATES.reaction_msec =  "R: " +react_time + " MSEC";
            displayBlock("green", pose.ctr_x, pose.bottom, 10, 10);  // DEBUG MARKER
        }
    } else {
        // for phantom reverse just detect a positive move towards new cone
        //
        var traveled_delta = 0;
        if (INFO.last_traveled) {
            traveled_delta = traveled - INFO.last_traveled;
            //if ((traveled > INFO.last_traveled) && (INFO.target_reacted === false)) {
            //if (((traveled >= 0) && (INFO.last_traveled < 0)) && (INFO.target_reacted === false)) {
            //if (( (INFO.last_traveled_delta >= 0) && (traveled_delta <= 0)) && (INFO.target_reacted === false)) {
            //if ((INFO.pose_reverse === true) && (INFO.target_reacted === false)) {
            //if (((traveled_delta >= 0) && (INFO.last_traveled_delta <= 0)) &&
            if ((traveled_delta >= 0) && 
                (INFO.last_traveled_plus > 1) &&
                (INFO.last_traveled_minus > 4) &&
                (INFO.target_reacted === false)) {
                // check or sign chg, reverse towards new goal
                //
                INFO.target_reacted = true;     // semaphore to avoid repeat
                TIMES.phantom_moving = Date.now();
                setFrameEvent("P-REACT"+INFO.rep_run_cnt+"-"+cone.name);
                //var lapse_time = (TIMES.phantom_moving - TIMES.start_phantom) / dratio;  // prorate back
                var lapse_time = (TIMES.phantom_moving - TIMES.start_phantom);
                react_time = Math.floor(lapse_time);
                REACT_STATES.preaction_msec = "P: " +react_time + " MSEC";
                console.log("goal.2442:  + + + + + + +  DISPLAY _PHANTOM_ REACTION TIME   hidx=",hidx, " x=",pose.ctr_x, " y=",pose.bottom,"  @ react=", react_time.toFixed(3), " phantom=", INFO.phantom_running, " to_goal=", Math.floor(action.goal_dist), "  start_dist=",cone.target_start_dist, "  traveled=",traveled, " femur=",INFO.femur_home_px);
                displayBlock("green", pose.ctr_x, pose.bottom, 10, 10);  // DEBUG MARKER
            }
        } else {
            INFO.last_traveled = traveled;
        }
        if (traveled_delta > 0)  {
            INFO.last_traveled_plus = INFO.last_traveled_plus + 1;
            //INFO.last_traveled_minus = 0;
        } else {
            INFO.last_traveled_minus = INFO.last_traveled_minus + 1;
            INFO.last_traveled_plus = 0;
        }
        INFO.last_traveled_delta = traveled_delta;
        INFO.last_traveled = traveled;
    }

    // if the target cone has a phantom, check to see if we reached and randomly reverse
    if ((INFO.phantom_reached === false) && (INFO.phantom_running === false) && (cone.phantom_id !== null) && (cone.phantom_id !== undefined)) {
        // check if we reached the phantom check point
        pid = cone.phantom_id;
        pcone_idx = getConeByID(pid, CONES);
        pcone = CONES[pcone_idx];
        if ((pcone_idx >= 0) && (pcone.valid  === true)) {
            [ preached, preacted, ptraveled, goal_dx, goal_dy, goal_dist ] = calcGoalDist(stats, pcone, pose);
            //console.log("goal.2454:                 _ _ _ B4  PRE-REACH _PHANTOM_ CHK   hidx=",hidx, " pcone=",pcone.name, " preacted=",preacted, " target_reacted=",INFO.target_reacted, " phantom=",INFO.phantom_running, " start_dist=",cone.target_start_dist, " goal_dist=",goal_dist);

            // reached the phantom spot, need to make sure primary reaction is first logged
            //
            //console.log("p_goal.1702:          CHK_GOAL  . . . . hidx=",hidx,"   phantom=",pcone.id,"  Reach_Cnt[]=", Reach_Cnt[pid], "  p.goal_dist=", goal_dist, " preached.now=",preached, "  already.reached=",INFO.phantom_reached);
            if (preached  === true) {
                if (Reach_Cnt[pid] > CONSTS.GOAL_MIN_PHANTOM_REPEAT) {
                    INFO.phantom_reached = true;
                    // ADVANCED MODE: MID-COURSE CHANGE TARGET
                    if(determineReverse()  === true) {
                        INFO.phantom_running = true;    // ends when we reach goal
                        INFO.target_reacted = false;    // need to reset for 2nd detect
                        End_Time[pid] = Date.now();

                        var cone_idx = findNextTarget(true);
                        var start_time = signalPlayer(cone_idx);
                        var ncone = CONES[cone_idx];
                        ncone.target_start_dist = calcDistance(stats, pose.ctr_x, ncone.ctr_x, pose.ctr_y, (ncone.ctr_y - ncone.dy)) + INFO.femur_home_px;  // count it when move towards new cone
                        console.log("goal.1045:        ####### ADVANCE SWITCHING ##### hidx=",hidx,"  NEW CONE name=",ncone.name, " id=",ncone.id, " orig.cone=", pcone.name, " ptraveled=",ptraveled, " new_start_dist=",ncone.target_start_dist," femur=",INFO.femur_home_px);

                        TIMES.start_phantom = start_time;



                        INFO.last_traveled = null;     // reset, use to detect direction chg
                        INFO.last_traveled_plus = 0;
                        INFO.last_traveled_minus = 0;




                        cone.display = "reverse";
                        pcone.display = "reverse";
                        setFrameEvent("SWITCH"+INFO.rep_run_cnt+"-"+CONES[INFO.target_idx].name);
                        playAudio(CONSTS.SWITCH_GOAL_PATH, "perf_phantom.2193");     // mid-course change
                    }
                }
            }
        } else {
            // not active phantom cone
            //console.log("goal.983:   INACTIVE PHANTOM ",cone.phantom_id);
        }
    }


    if(reached  === true) {
        //console.log("goal.1008:     # # # # # # # # #  GOAL REACHED ..... ",cone.id, " cnt=", Reach_Cnt[id], " goal_dist=",action.goal_dist);
        if(Reach_Cnt[id] > CONSTS.GOAL_MIN_MAIN_REPEAT) {
            End_Time[id] = Date.now();
            if (cone.home === false) { 
                console.log("goal.280:        + + + + + + GOAL REACHED +++++ ",cone.id, " hidx=",hidx, "  time=", Math.floor(End_Time[id]), " ", cone);
                playAudio(CONSTS.REP_SUCCESSS_PATH, "perf_goal1.2210");     // success chime
                setFrameEvent("GOAL"+INFO.rep_run_cnt+"-"+cone.name);
                INFO.phantom_running = false;    // ends when we reach goal
                INFO.target_idx = null;
                INFO.cone_target_x = 0;
                INFO.cone_target_y = 0;
                INFO.target_x = 0;
                INFO.target_y = 0;
                cone.display = null;
                cone.target = null;
                window.dispatchEvent(INFO.show_target_cone_event);       // tell UI to hide the <div> cone
            } else {
                console.log("goal.2499:       + + + + + +  HOME REACHED +++++ ",cone.id, " hidx=",hidx, "  time=", Math.floor(End_Time[id]), " ", cone);
            }

            if(Start_Time[id] === undefined) {
                return 666;   // for non-timed events like reaching home
            } else {
                console.log("goal.2223:                GOAL TIME   id=", id, "  end=",End_Time[id], " start=", Start_Time[id]);
                return End_Time[id] - Start_Time[id];
            }
        } else {
            reached = false;
        }
    } else {
        //console.log("goal.280:          RESET reach_cnt");
        Reach_Cnt[id] = 0;          // start over
    }

    return 0;
}



export function initPerformance() {
}